





























































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { BModal } from 'bootstrap-vue/esm/components/modal';
import { Camera } from '@/models/camera';
import { Project } from '@/models/project';
import { User } from '@/models/user';
import { Photo } from '@/models/photo';
import { Storage } from 'aws-amplify';
import { Crop, Position } from '@/models/enums';
import Gallery from '../components/gallery/gallery.component.vue';
import AWS from 'aws-sdk';
import axios from 'axios';
import { Auth } from 'aws-amplify';
// @ts-ignore: no d.ts file
import { vTeleport } from '@desislavsd/vue-teleport';
import { NotificationMessage, Socket } from '@/store/types';
import { Logger } from 'aws-amplify';
import * as d3 from 'd3';
import * as d3Array from 'd3-array';
import * as Plotly from 'plotly.js';
import { ModeBarDefaultButtons } from 'plotly.js';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// @ts-ignore: no d.ts file
import Datepicker from 'vuejs-datepicker';
// @ts-ignore: no d.ts file
import { en, fr } from 'vuejs-datepicker/dist/locale';
// @ts-ignore: no d.ts file
import logoImage from '@/assets/img/logo_bleu.png';
const logger = new Logger('Timelapse');

// Définir l'interface
interface BoundingBoxImage {
  url: string;
  label: string;
  confidence: string;
  key: string;
}

declare module 'jspdf' {
  interface jsPDF {
    getNumberOfPages(): number;
    putTotalPages(totalPagesExp: string): void;
  }
}

@Component({
  components: {
    Gallery,
    vTeleport,
    Datepicker,
  },
})
export default class IA extends Vue {
  @Prop(String) private id!: string;
  @Prop({ required: true, default: () => [] }) readonly dataImagesKey!: { data: Photo }[];

  @State('projects', { namespace: 'projects' }) private projects!: Project[];
  @State('premium', { namespace: 'profile' }) readonly isPremium!: boolean;
  @Getter('projectWithId', { namespace: 'projects' }) private projectWithId!: (id: string) => Project;

  @State('premium', { namespace: 'project' }) readonly ownerPremium!: boolean;
  @State('user', { namespace: 'profile' }) private user!: User;
  @Action('setProject', { namespace: 'project' }) private setProject!: (project: Project) => Promise<void>;
  @Action('loadTimelapse', { namespace: 'project' }) private loadTimelapse!: () => Promise<void>;
  @Action('findAllFor', { namespace: 'photo' }) private findPhotoAllForProject!: (payload: {
    projectId: string;
    cameraId: string;
  }) => Promise<Photo[]>;
  @State('photos', { namespace: 'photo' }) private readonly photosStore?: Photo[];
  @State('locale', { namespace: 'profile' }) private locale!: string;

  @State('socket') private socketMessage!: Socket;
  @Action('connectSocket') private connectSocket!: () => Promise<void>;
  @Action('disconnectSocket') private disconnectSocket!: () => Promise<void>;
  @Mutation('SOCKET_ONMESSAGE') private resetSocketMessage!: (object: string) => void;

  private loading = true;
  private isProjectLoading = true;
  private project: Project | null = null;
  private guest = false;
  private leftPanelVisible = true;
  private galleryVisible = true;
  private newPhotoAvailable = false;
  private galleryComparaison: string | null = null;
  private showChart = true;
  public hoverInfoPosition = { x: 0, y: 0 };
  private originalData: any[] = [];
  private currentXRange: [number, number] | null = null;
  private isChartInitialized = false;
  private boundingBoxImages: BoundingBoxImage[] = [];
  private lastActivityScore: number | null = null;
  private leftActivityScore: number | null = null;
  private lastPersonScore: number | null = null;
  private leftPersonScore: number | null = null;
  private lastNosafetyScore: number | null = null;
  private leftNosafetyScore: number | null = null;
  private lastDensityScore: number | null = null;
  private leftDensityScore: number | null = null;
  private lastHelmetScore: number | null = null;
  private leftHelmetScore: number | null = null;
  private lastFireScore: number | null = null;
  private leftFireScore: number | null = null;
  private lastCarScore: number | null = null;
  private leftCarScore: number | null = null;
  private lastCoactivityScore: number | null = null;
  private leftCoactivityScore: number | null = null;
  private startDate: string | null = null;
  private endDate: string | null = null;
  private firstPhotoDate: Date | null = null;
  private lastPhotoDate: Date | null = null;
  private updatingFromChart = false;
  private chartReady = false;
  private chartInitialized = false;
  private selectedRange: string | null = null;
  private selectedButton: number | null = null;
  private updatingFromDateRange = false;
  private timelapseRending = false;
  private loadingTimelapse = false;
  private selectedPhotos: Photo[] = [];
  private falseDetections: BoundingBoxImage[] = [];
  private logoUrl: string | null = null;
  private showLogoActions = false;
  private preloadedImage: HTMLImageElement | null = null;

  private polygonPoints: { x: number; y: number }[] = [];
  private polygonDrawing = false;
  private polygonCanvas: HTMLCanvasElement | null = null;
  private polygonCtx: CanvasRenderingContext2D | null = null;
  private originalPolygonPoints: { x: number; y: number }[] = [];
  private hasSavedPolygon = false;

  private backgroundImage: HTMLImageElement | null = null;
  private bgX = 0;
  private bgY = 0;
  private bgScale = 1;

  private modeSelected = 'Détection';
  private modeOptions: { text: string; value: string }[] = [
    { text: 'Détection', value: 'Détection' },
    { text: 'Sécurité', value: 'Sécurité' },
  ];

  get variation(): number {
    if (this.lastActivityScore !== null && this.leftActivityScore !== null && this.leftActivityScore !== 0) {
      return ((this.lastActivityScore - this.leftActivityScore) / this.leftActivityScore) * 100;
    }
    return 0;
  }

  get personVariation(): number {
    if (this.lastPersonScore !== null && this.leftPersonScore !== null && this.leftPersonScore !== 0) {
      return ((this.lastPersonScore - this.leftPersonScore) / this.leftPersonScore) * 100;
    }
    return 0;
  }

  get nosafetyVariation(): number {
    if (this.lastNosafetyScore !== null && this.leftNosafetyScore !== null && this.leftNosafetyScore !== 0) {
      return ((this.lastNosafetyScore - this.leftNosafetyScore) / this.leftNosafetyScore) * 100;
    }
    return 0;
  }

  get fireVariation(): number {
    if (this.lastFireScore !== null && this.leftFireScore !== null && this.leftFireScore !== 0) {
      return ((this.lastFireScore - this.leftFireScore) / this.leftFireScore) * 100;
    }
    return 0;
  }

  get carVariation(): number {
    if (this.lastCarScore !== null && this.leftCarScore !== null && this.leftCarScore !== 0) {
      return ((this.lastCarScore - this.leftCarScore) / this.leftCarScore) * 100;
    }
    return 0;
  }

  get coactivityVariation(): number {
    if (this.lastCoactivityScore !== null && this.leftCoactivityScore !== null && this.leftCoactivityScore !== 0) {
      return ((this.lastCoactivityScore - this.leftCoactivityScore) / this.leftCoactivityScore) * 100;
    }
    return 0;
  }

  get densityVariation(): number {
    if (this.lastDensityScore !== null && this.leftDensityScore !== null && this.leftDensityScore !== 0) {
      return ((this.lastDensityScore - this.leftDensityScore) / this.leftDensityScore) * 100;
    }
    return 0;
  }

  get helmetVariation(): number {
    if (this.lastHelmetScore !== null && this.leftHelmetScore !== null && this.leftHelmetScore !== 0) {
      return ((this.lastHelmetScore - this.leftHelmetScore) / this.leftHelmetScore) * 100;
    }
    return 0;
  }

  get epiVariation(): number {
    if (this.lastHelmetScore !== null && this.leftHelmetScore !== null && this.leftHelmetScore !== 0) {
      return ((this.lastHelmetScore - this.leftHelmetScore) / this.leftHelmetScore) * 100;
    }
    return 0;
  }

  public get breadcrumbs(): unknown[] {
    const items = [
      {
        text: this.$tc('global.project', 2),
        to: '/',
      },
    ];
    if (this.project !== null) {
      items.push({
        text: this.project.name,
        to: '/project/' + this.project.id,
      });
    }
    items.push({
      text: this.$tc('global.timelapse'),
      to: '#',
    });
    return items;
  }

  public get datepickerLocal(): unknown {
    return this.locale === 'en' ? en : fr;
  }

  public getRotation(): string {
    return this.camera && this.camera.rotate ? `rotate(${this.camera.rotate}deg)` : '';
  }

  resizing = false;

  startResize(event: MouseEvent) {
    this.resizing = true;
    window.addEventListener('mousemove', this.performResize);
    window.addEventListener('mouseup', this.stopResize);
  }

  performResize(event: MouseEvent) {
    if (this.resizing) {
      const leftElement = this.$el.querySelector('.left') as HTMLElement;
      const galleryContainer = this.$el.querySelector('.gallery-container') as HTMLElement;
      if (leftElement && galleryContainer) {
        // Calcul de la nouvelle largeur en pourcentage de la fenêtre
        const newWidthPercentage = (event.clientX / window.innerWidth) * 100;

        // Limiter la largeur entre 30vw et 70vw pour .left
        const adjustedWidth = Math.min(Math.max(newWidthPercentage, 30), 100); // Ajustez les limites si nécessaire

        // Appliquer la nouvelle largeur à .left et ajuster .gallery-container
        leftElement.style.width = `${adjustedWidth}vw`;
        galleryContainer.style.width = `${100 - adjustedWidth}vw`;

        // Redimensionner le graphique si nécessaire
        const plotDiv = this.$refs.chart as HTMLElement;
        if (plotDiv) {
          Plotly.Plots.resize(plotDiv);
        }
      }
    }
  }

  stopResize() {
    if (this.resizing) {
      this.resizing = false;
      window.removeEventListener('mousemove', this.performResize);
      window.removeEventListener('mouseup', this.stopResize);
    }
  }

  private getPhotoDates(): void {
    if (this.dataImagesKey.length > 0) {
      // Trier les photos par date
      const sortedPhotos = this.dataImagesKey.slice().sort((a, b) => {
        return new Date(a.data.createdAt).getTime() - new Date(b.data.createdAt).getTime();
      });
      this.firstPhotoDate = new Date(sortedPhotos[0].data.createdAt);
      this.lastPhotoDate = new Date(sortedPhotos[sortedPhotos.length - 1].data.createdAt);
    }
  }

  public toggleLeftPanel() {
    // Basculer l'état du panneau de gauche
    this.leftPanelVisible = !this.leftPanelVisible;

    // Sélectionner les éléments du DOM
    const leftElement = this.$el.querySelector('.left') as HTMLElement;
    const galleryContainer = this.$el.querySelector('.gallery-container') as HTMLElement;

    if (leftElement && galleryContainer) {
      if (this.leftPanelVisible) {
        // Restaurer les largeurs initiales
        leftElement.style.width = '60vw';
        galleryContainer.style.width = '40vw';
        galleryContainer.classList.remove('hidden');
      } else {
        // Agrandir le panneau gauche et masquer la galerie
        leftElement.style.width = '100vw';
        galleryContainer.style.width = '0vw';
        galleryContainer.classList.add('hidden');
      }

      // Redimensionner le graphique après la mise à jour du DOM
      this.$nextTick(() => {
        const plotDiv = this.$refs.chart as HTMLElement;
        if (plotDiv && this.isChartInitialized) {
          Plotly.Plots.resize(plotDiv);
        }
      });
    }
  }

  public get cameraSelected(): string | null {
    return (this.$route.query.camera as string) || null;
  }
  public set cameraSelected(s: string | null) {
    logger.info('set cameraSelected', s);
    if (s !== null) {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, camera: s } });
    }
  }

  public get camera(): Camera | undefined {
    logger.info('get camera ' + this.cameraSelected);
    return (
      this.project?.cameras?.find((camera: Camera) => camera.id === this.cameraSelected) ||
      this.project?.previousCameras?.find((camera: Camera) => camera.id === this.cameraSelected)
    );
  }

  public get camerasOptions(): unknown[] {
    const project = this.project;
    const data = [
      ...(project?.cameras?.map((camera) => ({
        text: `${camera.name}`,
        value: camera.id,
      })) ?? []),
      ...(project?.previousCameras?.map((camera) => ({
        text: `${camera.name} (deleted)`,
        value: camera.id,
      })) ?? []),
    ];
    if (data.length > 0) {
      return data;
    } else {
      return [{ text: 'Aucune caméra disponible', value: null }];
    }
  }

  public get filteredBoundingBoxImages(): BoundingBoxImage[] {
    return this.boundingBoxImages.filter((img) => !img.key.endsWith('safety-segmentation.jpg'));
  }

  public get filteredSegmentationImages(): BoundingBoxImage[] {
    return this.boundingBoxImages;
  }

  public async mounted(): Promise<void> {
    try {
      this.loading = true;

      // Charger le projet si nécessaire
      if (!this.project) {
        this.project = this.projectWithId(this.id);
        this.setProject(this.project);
        this.isProjectLoading = false;
      }

      // Charger les photos de la caméra si cameraSelected est défini
      if (this.cameraSelected !== null) {
        await this.loadCameraPhotos();
      }

      this.getPhotoDates();
      if (this.firstPhotoDate) {
        this.startDate = this.formatDateForInput(this.firstPhotoDate);
      }
      if (this.lastPhotoDate) {
        // Ajuster la date de fin pour inclure toute la journée
        const endDate = new Date(this.lastPhotoDate);
        endDate.setHours(23, 59, 59, 999);
        this.endDate = this.formatDateForInput(endDate);
      }
    } catch (error) {
      console.error('Erreur lors du chargement:', error);
    } finally {
      this.loading = false;
    }
    await this.$nextTick();
    if (this.modeSelected === 'Sécurité') {
      this.createSecurityChart();
    } else {
      this.createChart();
    }

    // Définir les largeurs initiales
    const leftElement = this.$el.querySelector('.left') as HTMLElement;
    const galleryContainer = this.$el.querySelector('.gallery-container') as HTMLElement;
    if (leftElement && galleryContainer) {
      leftElement.style.width = '60vw';
      galleryContainer.style.width = '40vw';
    }
  }

  private formatDateForInput(date: Date): string {
    // Formate la date en 'YYYY-MM-DDTHH:mm:ss' pour inclure l'heure
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  private formatDate(dateStr: string, locale: string): string {
    const date = new Date(dateStr);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false, // Format 24h
    };
    return date.toLocaleString(locale, options);
  }

  private async loadCameraPhotos(): Promise<void> {
    if (this.cameraSelected !== null) {
      const camera = this.project?.cameras?.find((cam) => cam.id === this.cameraSelected);
      const photos = await this.findPhotoAllForProject({ projectId: this.id, cameraId: this.cameraSelected });

      if (photos && photos.length > 0) {
        const newImages = photos.map((photo) => ({ data: Vue.set({}, 'data', photo) }));
        this.$set(this, 'dataImagesKey', newImages);
        await this.$nextTick(); // S'assurer que le DOM est mis à jour

        // Charger les URLs des images une seule fois ici
        let data = await Promise.all(
          this.dataImagesKey.map(async (photo) => {
            const imageUrl = await Storage.get(photo.data.smallKey);
            return {
              photoId: photo.data.id,
              date: new Date(photo.data.createdAt),
              toupie: Number(photo.data.detectedLabels?.toupie ?? 0),
              crane: Number(photo.data.detectedLabels?.crane ?? 0),
              nacelle: Number(photo.data.detectedLabels?.nacelle ?? 0),
              pelle: Number(photo.data.detectedLabels?.pelle ?? 0),
              person: Number(photo.data.detectedLabels?.Person ?? 0),
              benne: Number(photo.data.detectedLabels?.benne ?? 0),
              compacteuse: Number(photo.data.detectedLabels?.compateuse ?? 0),
              mobilecrane: Number(photo.data.detectedLabels?.gruemobile ?? 0),
              camion: Number(photo.data.detectedLabels?.camion ?? 0),
              foreuse: Number(photo.data.detectedLabels?.foreuse ?? 0),
              density: Number(photo.data.detectedLabels?.density ?? 0),
              movement: Number(photo.data.detectedLabels?.movement ?? 0),
              helmet: Number(photo.data.detectedLabels?.helmet ?? 0),
              vest: Number(photo.data.detectedLabels?.vest ?? 0),
              excavation: Number(photo.data.detectedLabels?.excavation ?? 0),
              filet: Number(photo.data.detectedLabels?.filet ?? 0),
              gc: Number(photo.data.detectedLabels?.gc ?? 0),
              heras: Number(photo.data.detectedLabels?.heras ?? 0),
              no_safety: Number(photo.data.detectedLabels?.no_safety ?? 0),
              rubalise: Number(photo.data.detectedLabels?.rubalise ?? 0),
              coactivity: Number(photo.data.detectedLabels?.coactivity ?? 0),
              fire: Number(photo.data.detectedLabels?.fire ?? 0),
              car: Number(photo.data.detectedLabels?.car ?? 0),
              imageUrl,
            };
          })
        );

        data = data.filter((d) => d.date && d.imageUrl && d.photoId);

        // Trier les données par date
        data.sort((a, b) => a.date.getTime() - b.date.getTime());

        // Stocker les données chargées dans this.originalData
        this.originalData = data;

        // Obtenir les dates des photos pour initialiser les sélecteurs de date
        this.getPhotoDates();
        if (this.firstPhotoDate) {
          this.startDate = this.formatDateForInput(this.firstPhotoDate);
        }
        if (this.lastPhotoDate) {
          this.endDate = this.formatDateForInput(this.lastPhotoDate);
        }
      } else {
        console.error('Aucune photo trouvée ou réponse invalide:', photos);
      }
    }
  }

  public openStartDatepicker(): void {
    (this.$refs.startDatepicker as any).showCalendar();
  }

  public openEndDatepicker(): void {
    (this.$refs.endDatepicker as any).showCalendar();
  }

  public beforeDestroy(): void {
    logger.info('beforeDestroy');
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.disconnectSocket();
  }

  public refreshPhoto(): void {
    if (this.cameraSelected !== null) {
      this.findPhotoAllForProject({ projectId: this.id, cameraId: this.cameraSelected }).then(() => {
        this.newPhotoAvailable = false;
      });
    }
  }

  private async loadPolygonPhoto(): Promise<void> {
    if (this.preloadedImage) {
      this.backgroundImage = this.preloadedImage;
      if (this.polygonCtx && this.polygonCanvas) {
        const scale = Math.min(
          this.polygonCanvas.width / this.backgroundImage.width,
          this.polygonCanvas.height / this.backgroundImage.height
        );
        const x = (this.polygonCanvas.width - this.backgroundImage.width * scale) / 2;
        const y = (this.polygonCanvas.height - this.backgroundImage.height * scale) / 2;
        this.bgScale = scale;
        this.bgX = x;
        this.bgY = y;
        this.drawPolygon();
      }
    } else {
      // Fallback si l'image n'est pas préchargée
      let photo: Photo | null = null;
      if (this.selectedPhotos && this.selectedPhotos.length > 0) {
        photo = this.selectedPhotos[this.selectedPhotos.length - 1];
      } else if (this.dataImagesKey && this.dataImagesKey.length > 0) {
        photo = this.dataImagesKey[this.dataImagesKey.length - 1].data;
      }
      if (!photo) return;

      try {
        const key = photo.key || photo.smallKey;
        const photoUrl = await Storage.get(key);
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
          if (this.polygonCtx && this.polygonCanvas) {
            const scale = Math.min(this.polygonCanvas.width / img.width, this.polygonCanvas.height / img.height);
            const x = (this.polygonCanvas.width - img.width * scale) / 2;
            const y = (this.polygonCanvas.height - img.height * scale) / 2;
            this.backgroundImage = img;
            this.bgScale = scale;
            this.bgX = x;
            this.bgY = y;
            this.drawPolygon();
          }
        };
        img.src = photoUrl as string;
      } catch (error) {
        console.error("Erreur lors du chargement de l'image pour le traçage:", error);
      }
    }
  }

  public openPolygonModal(): void {
    // On suppose que vous avez ajouté dans votre template une modale avec la référence "polygonModal"
    (this.$refs.polygonModal as BModal).show();
  }

  private async loadPolygonPoints(): Promise<void> {
    try {
      const credentials = await Auth.currentCredentials();
      const dynamoDb = new AWS.DynamoDB.DocumentClient({
        region: 'eu-west-3', // Adaptez à votre région AWS
        credentials,
      });

      const params = {
        TableName: 'erige-cameras-prod',
        Key: {
          id: this.camera?.id, // L'ID de la caméra sélectionnée
        },
      };

      const result = await dynamoDb.get(params).promise();
      if (result.Item && result.Item.polygonPoints) {
        this.polygonPoints = result.Item.polygonPoints;
      } else {
        this.polygonPoints = []; // Réinitialiser uniquement si aucun point n'existe
      }
    } catch (error) {
      console.error('Erreur lors du chargement des points du polygone :', error);
      this.polygonPoints = [];
    }
  }

  // Méthode appelée lors de l'affichage de la modale (via l'événement @shown)
  public onPolygonModalShown(): void {
    this.originalPolygonPoints = [...this.polygonPoints]; // Sauvegarde des points originaux
    this.hasSavedPolygon = false;
    this.polygonCanvas = document.getElementById('polygon-canvas') as HTMLCanvasElement;
    if (this.polygonCanvas) {
      this.polygonCtx = this.polygonCanvas.getContext('2d');
      if (this.polygonCtx) {
        this.polygonCtx.clearRect(0, 0, this.polygonCanvas.width, this.polygonCanvas.height);
      }
      this.polygonDrawing = true;
      this.addPolygonCanvasListeners();
      this.loadPolygonPhoto();
    }
  }

  // Installation des écouteurs d'événements sur le canvas
  private addPolygonCanvasListeners(): void {
    if (this.polygonCanvas) {
      this.polygonCanvas.addEventListener('click', this.handlePolygonCanvasClick.bind(this));
      this.polygonCanvas.addEventListener('contextmenu', this.handlePolygonCanvasRightClick.bind(this));
    }
  }

  // Gestion du clic gauche sur le canvas : ajouter un point
  private handlePolygonCanvasClick(e: MouseEvent): void {
    if (!this.polygonCanvas) return;
    const rect = this.polygonCanvas.getBoundingClientRect();
    const xCanvas = ((e.clientX - rect.left) / (rect.right - rect.left)) * this.polygonCanvas.width;
    const yCanvas = ((e.clientY - rect.top) / (rect.bottom - rect.top)) * this.polygonCanvas.height;

    // Conversion des coordonnées vers celles de l'image
    const xImage = (xCanvas - this.bgX) / this.bgScale;
    const yImage = (yCanvas - this.bgY) / this.bgScale;
    this.polygonPoints.push({ x: Math.round(xImage), y: Math.round(yImage) });
    console.info('Point ajouté (coordonnées image):', { x: xImage, y: yImage });
    this.drawPolygon();
  }

  // Gestion du clic droit pour fermer le polygone
  private handlePolygonCanvasRightClick(e: MouseEvent): void {
    e.preventDefault();
    this.completePolygon();
  }

  // Ferme le polygone en reliant le dernier point au premier (si suffisamment de points)
  private completePolygon(): void {
    if (this.polygonPoints.length > 2) {
      // Fermer le polygone en réutilisant le premier point
      this.polygonPoints.push({ ...this.polygonPoints[0] });
      this.drawPolygon();
      this.polygonDrawing = false;
    } else {
      console.error('Nombre insuffisant de points pour fermer le polygone');
    }
  }

  // Fonction de dessin du polygone sur le canvas
  private drawPolygon(): void {
    if (!this.polygonCtx || !this.polygonCanvas) return;
    // Effacer le canvas
    this.polygonCtx.clearRect(0, 0, this.polygonCanvas.width, this.polygonCanvas.height);

    // 1. Dessiner l'image de fond (non floutée)
    if (this.backgroundImage) {
      this.polygonCtx.drawImage(
        this.backgroundImage,
        this.bgX,
        this.bgY,
        this.backgroundImage.width * this.bgScale,
        this.backgroundImage.height * this.bgScale
      );
    }

    // 2. Si au moins 3 points, appliquer le flou sur l'extérieur du polygone
    if (this.polygonPoints.length >= 3) {
      // Sauvegarder le contexte
      this.polygonCtx.save();
      this.polygonCtx.beginPath();
      // Dessiner un rectangle couvrant tout le canvas
      this.polygonCtx.rect(0, 0, this.polygonCanvas.width, this.polygonCanvas.height);
      // Dessiner le polygone (la zone à ne pas flouter)
      this.polygonCtx.moveTo(
        this.bgX + this.polygonPoints[0].x * this.bgScale,
        this.bgY + this.polygonPoints[0].y * this.bgScale
      );
      for (let i = 1; i < this.polygonPoints.length; i++) {
        this.polygonCtx.lineTo(
          this.bgX + this.polygonPoints[i].x * this.bgScale,
          this.bgY + this.polygonPoints[i].y * this.bgScale
        );
      }
      this.polygonCtx.closePath();
      // Utiliser la règle "evenodd" pour inverser le clipping
      this.polygonCtx.clip('evenodd');

      // Appliquer le flou et redessiner l'image dans la zone clipée (l'extérieur)
      this.polygonCtx.filter = 'blur(5px)'; // Ajustez la valeur du flou si nécessaire
      if (this.backgroundImage) {
        this.polygonCtx.drawImage(
          this.backgroundImage,
          this.bgX,
          this.bgY,
          this.backgroundImage.width * this.bgScale,
          this.backgroundImage.height * this.bgScale
        );
      }
      // Restaurer le contexte pour désactiver le clipping et le filtre
      this.polygonCtx.restore();
    }

    // 3. Tracer le contour du polygone (ou la polyline s'il y a moins de 3 points)
    if (this.polygonPoints.length > 0) {
      this.polygonCtx.beginPath();
      this.polygonCtx.moveTo(
        this.bgX + this.polygonPoints[0].x * this.bgScale,
        this.bgY + this.polygonPoints[0].y * this.bgScale
      );
      for (let i = 1; i < this.polygonPoints.length; i++) {
        this.polygonCtx.lineTo(
          this.bgX + this.polygonPoints[i].x * this.bgScale,
          this.bgY + this.polygonPoints[i].y * this.bgScale
        );
      }
      // Si au moins 3 points, fermer le chemin pour relier le dernier au premier
      if (this.polygonPoints.length >= 3) {
        this.polygonCtx.closePath();
      }
      this.polygonCtx.strokeStyle = '#FF0000';
      this.polygonCtx.lineWidth = 2;
      this.polygonCtx.stroke();
    }
  }

  // Méthode pour réinitialiser le tracé et commencer une nouvelle zone
  public startNewPolygon(): void {
    this.polygonPoints = [];
    this.polygonDrawing = true;
    this.drawPolygon();
  }

  // Méthode pour sauvegarder le polygone (ici, vous pouvez ensuite envoyer this.polygonPoints vers DynamoDB)
  public async savePolygon(): Promise<void> {
    console.info('Polygone enregistré :', this.polygonPoints);
    // Exemple d'enregistrement dans DynamoDB avec AWS SDK DocumentClient
    try {
      // Obtenir les credentials via Amplify
      const credentials = await Auth.currentCredentials();

      // Créer une instance du DocumentClient
      const dynamoDb = new AWS.DynamoDB.DocumentClient({
        region: 'eu-west-3', // Adaptez à votre région
        credentials,
      });

      // Préparer les paramètres pour l'insertion
      const params = {
        TableName: 'erige-cameras-prod',
        Key: {
          id: this.camera?.id, // supposé être la clé primaire de votre élément
        },
        UpdateExpression: 'SET polygonPoints = :p',
        ExpressionAttributeValues: {
          ':p': this.polygonPoints,
        },
      };
      // Enregistrer dans DynamoDB
      dynamoDb.update(params, (err, data) => {
        if (err) {
          console.error('Erreur lors de la mise à jour :', err);
        } else {
          console.log('Mise à jour réussie :', data);
        }
      });
      console.log('Coordonnées sauvegardées dans DynamoDB');
      this.hasSavedPolygon = true;
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des coordonnées dans DynamoDB :", error);
    }
    // Fermer la modale
    this.closePolygonModal();
  }

  // Méthode pour fermer la modale de traçage
  public closePolygonModal(): void {
    if (!this.hasSavedPolygon) {
      this.polygonPoints = [...this.originalPolygonPoints]; // Restaurer les points originaux
    }
    (this.$refs.polygonModal as BModal).hide();
  }

  private triggerDatePicker(id: string): void {
    const inputElement = document.getElementById(id) as HTMLInputElement;
    if (inputElement) {
      inputElement.focus(); // Donne le focus à l'input
      inputElement.click(); // Simule un clic pour ouvrir le calendrier
    }
  }

  private loadImageAsDataURL(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Pour éviter les problèmes CORS
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        } else {
          reject('Canvas context not available');
        }
      };
      img.onerror = () => {
        reject('Failed to load image');
      };
      img.src = url;
    });
  }

  private async generateReportPDF() {
    if (!this.originalData || this.originalData.length === 0) {
      console.error('Aucune donnée disponible pour générer le rapport.');
      return;
    }

    // Importation du logo
    const logoDataURL = await this.loadImageAsDataURL(logoImage);

    // Initialisation de jsPDF en mode paysage
    const doc = new jsPDF({ orientation: 'landscape' });
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 10;

    const totalPagesExp = '{total_pages_count_string}';

    // Déterminer la locale pour le formatage des dates
    const locale = this.$i18n.locale; // Par exemple, 'fr', 'en', 'it', 'de', 'es'

    // Fonctions pour ajouter l'en-tête et le pied de page
    const addHeader = (doc: jsPDF) => {
      doc.setFontSize(18);
      doc.setTextColor(0, 0, 128);
      const title =
        this.modeSelected === 'Sécurité' ? this.$t('ia.securityReportTitle') : this.$t('ia.activityReportTitle');
      const titleStr = String(title);
      const titleWidth = doc.getTextWidth(titleStr);
      const xTitle = (pageWidth - titleWidth) / 2;
      doc.text(titleStr, xTitle, 20);
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(`${this.$t('ia.project')}: ${this.project?.name}`, margin, 20);

      // Ajout du logo en haut à droite
      const imgWidth = 40;
      const imgHeight = 10;
      const xPosition = pageWidth - imgWidth - margin;
      const yPosition = margin;
      doc.addImage(logoDataURL, 'PNG', xPosition, yPosition, imgWidth, imgHeight);

      // Ligne séparatrice
      doc.setLineWidth(0.5);
      doc.line(margin, 45, pageWidth - margin, 45);
    };

    const addFooter = (doc: jsPDF, pageNumber: number) => {
      const currentDate = new Date().toLocaleDateString(locale);
      doc.setFontSize(10);
      doc.text(`${this.$t('ia.generatedOn')}: ${currentDate}`, margin, pageHeight - 10);
      const pageText = `${this.$t('ia.page')} ${pageNumber} / ${totalPagesExp}`;
      const pageTextWidth = doc.getTextWidth(pageText);
      doc.text(pageText, pageWidth - margin - 20, pageHeight - 10);
    };

    // Ajout de l'en-tête et du pied de page à la première page
    addHeader(doc);
    addFooter(doc, 1);

    // Préparation des données pour le rapport
    const preparedData = this.prepareData(this.originalData);
    const { xData, aggregatedData, categories } = preparedData;

    if (this.modeSelected === 'Sécurité') {
      // --- Rapport pour le mode Sécurité ---
      // Calcul des statistiques pour le résumé exécutif
      const totalSafetyDetections = this.originalData.reduce((total, item) => {
        return total + (item.no_safety || 0) + (item.fire || 0) + (item.coactivity || 0) + (item.car || 0);
      }, 0);

      const safetyLabelCounts = {
        no_safety: aggregatedData['no_safety']?.reduce((sum: number, val: number) => sum + val, 0) || 0,
        fire: aggregatedData['fire']?.reduce((sum: number, val: number) => sum + val, 0) || 0,
        coactivity: aggregatedData['coactivity']?.reduce((sum: number, val: number) => sum + val, 0) || 0,
        car: aggregatedData['car']?.reduce((sum: number, val: number) => sum + val, 0) || 0,
      };

      const topSafetyLabels = Object.entries(safetyLabelCounts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 4)
        .map(([label]) => this.$t(`ia.${label}`))
        .join(', ');

      // Résumé exécutif
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.summary')), margin, 55);

      doc.setLineWidth(0.5);
      doc.line(margin, 60, pageWidth - margin, 60);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      const formattedStartDate = this.formatDate(this.startDate ?? '', locale);
      const formattedEndDate = this.formatDate(this.endDate ?? '', locale);
      doc.text(`${this.$t('ia.period')}: ${formattedStartDate} ${this.$t('ia.to')} ${formattedEndDate}`, margin, 68);
      doc.text(`${this.$t('ia.totalSafetyDetections')}: ${totalSafetyDetections.toFixed(0)}`, margin, 78);
      doc.text(`${this.$t('ia.topSafetyLabels')}: ${topSafetyLabels || this.$t('ia.none')}`, margin, 88);

      // Scores de sécurité
      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.scores')), margin, 108);

      doc.setLineWidth(0.5);
      doc.line(margin, 111, pageWidth - margin, 111);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(
        `${this.$t('ia.no_safety')}: ${this.lastNosafetyScore?.toFixed(1) || 'N/A'} / ${
          this.leftNosafetyScore?.toFixed(1) || 'N/A'
        } (${this.nosafetyVariation > 0 ? '+' : ''}${this.nosafetyVariation.toFixed(1)}%)`,
        margin,
        121
      );
      doc.text(
        `${this.$t('ia.fire')}: ${this.lastFireScore?.toFixed(1) || 'N/A'} / ${
          this.leftFireScore?.toFixed(1) || 'N/A'
        } (${this.fireVariation > 0 ? '+' : ''}${this.fireVariation.toFixed(1)}%)`,
        margin,
        131
      );
      doc.text(
        `${this.$t('ia.coactivity')}: ${this.lastCoactivityScore?.toFixed(1) || 'N/A'} / ${
          this.leftCoactivityScore?.toFixed(1) || 'N/A'
        } (${this.coactivityVariation > 0 ? '+' : ''}${this.coactivityVariation.toFixed(1)}%)`,
        margin,
        141
      );
      doc.text(`${this.$t('ia.car')}: ${safetyLabelCounts.car}`, margin, 151);

      // Saut de page
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      // Graphique principal pour la sécurité
      const safetyTraces = [
        this.createLabelTrace(preparedData, 'no_safety'),
        this.createLabelTrace(preparedData, 'fire'),
        this.createLabelTrace(preparedData, 'coactivity'),
        this.createLabelTrace(preparedData, 'car'),
      ].filter((trace) => Array.isArray(trace.y) && trace.y.some((val: any) => typeof val === 'number' && val > 0)); // Filtrer les traces vides
      const safetyLayout = this.createLayout();
      safetyLayout.title = { text: String(this.$t('ia.safetyTrends')), x: 0.5, xanchor: 'center' };
      safetyLayout.paper_bgcolor = 'white';
      safetyLayout.plot_bgcolor = 'white';
      const config = this.createConfig();

      const plotDiv = document.createElement('div');
      await Plotly.newPlot(plotDiv, safetyTraces as Plotly.Data[], safetyLayout, config);
      const safetyChartImage = await Plotly.toImage(plotDiv, {
        format: 'jpeg',
        width: 2000,
        height: 1200,
      });

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.mainSafetyChart')), margin, 50);

      doc.setLineWidth(0.5);
      doc.line(margin, 53, pageWidth - margin, 53);

      doc.addImage(safetyChartImage, 'JPEG', margin, 60, pageWidth - 2 * margin, pageHeight - 80);

      // Graphiques individuels pour chaque métrique de sécurité
      const safetyLabels = ['no_safety', 'fire', 'coactivity', 'car'];
      for (const label of safetyLabels) {
        doc.addPage();
        addHeader(doc);
        addFooter(doc, doc.getNumberOfPages());

        const labelTrace = this.createLabelTrace(preparedData, label);
        const labelLayout = this.createLayoutForLabel(label);
        await Plotly.newPlot(plotDiv, [labelTrace as Plotly.Data], labelLayout, config);

        const labelImage = await Plotly.toImage(plotDiv, {
          format: 'jpeg',
          width: 2000,
          height: 1200,
        });

        doc.setFontSize(13);
        doc.setTextColor(0, 0, 128);
        doc.text(`${this.$t('ia.labelTrend')} ${this.$t(`ia.${label}`)}`, margin, 50);

        doc.setLineWidth(0.5);
        doc.line(margin, 53, pageWidth - margin, 53);

        doc.addImage(labelImage, 'JPEG', margin, 60, pageWidth - 2 * margin, pageHeight - 80);
      }

      // Conclusion
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      doc.setFontSize(14);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.conclusion')), margin, 50);

      doc.setLineWidth(0.5);
      doc.line(margin, 53, pageWidth - margin, 53);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(String(this.$t('ia.safetyConclusion')), margin, 63, { maxWidth: pageWidth - 2 * margin });
    } else {
      // --- Rapport pour le mode Activité/Détection (logique existante) ---

      // Calcul des statistiques pour le résumé exécutif
      let averageActivityScore = 0;
      if (this.lastActivityScore !== null && this.leftActivityScore !== null) {
        averageActivityScore = (this.lastActivityScore + this.leftActivityScore) / 2;
      }

      const activityVariation =
        this.leftActivityScore !== null && this.leftActivityScore !== 0 && this.lastActivityScore !== null
          ? ((this.lastActivityScore - this.leftActivityScore) / this.leftActivityScore) * 100
          : 0;

      const totalDetections = this.originalData.reduce((total, item) => {
        return (
          total +
          categories.reduce((sum, { key }) => {
            return sum + item[key];
          }, 0)
        );
      }, 0);
      const labelCounts = categories.reduce((acc, { key }) => {
        acc[key] = aggregatedData[key].reduce((sum: number, val: number) => sum + val, 0);
        return acc;
      }, {} as Record<string, number>);

      const topLabels = Object.entries(labelCounts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([label]) => label)
        .join(', ');

      // Résumé exécutif
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.summary')), margin, 55);

      doc.setLineWidth(0.5);
      doc.line(margin, 60, pageWidth - margin, 60);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      const formattedStartDate = this.formatDate(this.startDate ?? '', locale);
      const formattedEndDate = this.formatDate(this.endDate ?? '', locale);
      doc.text(`${this.$t('ia.period')}: ${formattedStartDate} ${this.$t('ia.to')} ${formattedEndDate}`, margin, 68);
      doc.text(`${this.$t('ia.averageActivityScore')}: ${averageActivityScore.toFixed(2)}`, margin, 78);
      doc.text(`${this.$t('ia.totalDetections')}: ${totalDetections.toFixed(0)}`, margin, 88);
      doc.text(`${this.$t('ia.topLabels')}: ${topLabels}`, margin, 98);

      // Scores
      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.scores')), margin, 123);

      doc.setLineWidth(0.5);
      doc.line(margin, 126, pageWidth - margin, 126);

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(
        `${this.$t('ia.activityScore')}: ${this.lastActivityScore?.toFixed(1)} / ${this.leftActivityScore?.toFixed(1)}`,
        margin,
        136
      );
      doc.text(
        `${this.$t('ia.densityScore')}: ${this.lastDensityScore?.toFixed(1)} / ${this.leftDensityScore?.toFixed(1)}`,
        margin,
        146
      );
      doc.text(
        `${this.$t('ia.personScore')}: ${this.lastPersonScore?.toFixed(1)} / ${this.leftPersonScore?.toFixed(1)}`,
        margin,
        156
      );
      doc.text(
        `${this.$t('ia.helmetScore')}: ${this.lastHelmetScore?.toFixed(1)}% / ${this.leftHelmetScore?.toFixed(1)}%`,
        margin,
        166
      );

      // Saut de page
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      // Graphique principal
      const fullTraces = this.createTraces(preparedData, true);
      const fullLayout = this.createLayout();
      fullLayout.paper_bgcolor = 'white';
      fullLayout.plot_bgcolor = 'white';
      const config = this.createConfig();

      const plotDiv = document.createElement('div');
      await Plotly.newPlot(plotDiv, fullTraces as Plotly.Data[], fullLayout, config);
      const fullChartImage = await Plotly.toImage(plotDiv, {
        format: 'jpeg',
        width: 2000,
        height: 1200,
      });

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(String(this.$t('ia.mainChart')), margin, 50);

      doc.setLineWidth(0.5);
      doc.line(margin, 53, pageWidth - margin, 53);

      doc.addImage(fullChartImage, 'JPEG', margin, 60, pageWidth - 2 * margin, pageHeight - 80);

      // Graphique Activité & Densité
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      let yOffset = 50;

      const activityDensityTraces = this.createActivityDensityTraces(preparedData);
      const activityDensityLayout = this.createLayout();
      activityDensityLayout.paper_bgcolor = 'white';
      activityDensityLayout.plot_bgcolor = 'white';
      await Plotly.newPlot(plotDiv, activityDensityTraces, activityDensityLayout, config);
      const activityDensityImage = await Plotly.toImage(plotDiv, {
        format: 'jpeg',
        width: 2000,
        height: 1200,
      });

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(this.$t('ia.activityDensityChart').toString(), margin, yOffset);

      doc.setLineWidth(0.5);
      doc.line(margin, yOffset + 3, pageWidth - margin, yOffset + 3);

      yOffset += 10;

      doc.addImage(activityDensityImage, 'JPEG', margin, yOffset, pageWidth - 2 * margin, pageHeight - yOffset - 30);

      // Graphique Personnes & Ratio Casque/Personne
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      yOffset = 50;

      const personAndHelmetRatioTraces = this.createPersonAndHelmetRatioGraph(preparedData);
      const personAndHelmetRatioLayout = this.createLayoutForPersonAndHelmetRatio();
      await Plotly.newPlot(plotDiv, personAndHelmetRatioTraces, personAndHelmetRatioLayout, config);
      const personAndHelmetRatioImage = await Plotly.toImage(plotDiv, {
        format: 'jpeg',
        width: 2000,
        height: 1200,
      });

      doc.setFontSize(13);
      doc.setTextColor(0, 0, 128);
      doc.text(this.$t('ia.personHelmetChart').toString(), margin, yOffset);

      doc.setLineWidth(0.5);
      doc.line(margin, yOffset + 3, pageWidth - margin, yOffset + 3);

      yOffset += 10;

      doc.addImage(
        personAndHelmetRatioImage,
        'JPEG',
        margin,
        yOffset,
        pageWidth - 2 * margin,
        pageHeight - yOffset - 30
      );

      // Graphiques individuels pour chaque label
      const labels = [
        'toupie',
        'crane',
        'nacelle',
        'pelle',
        'person',
        'benne',
        'compacteuse',
        'mobilecrane',
        'camion',
        'foreuse',
      ];

      for (const label of labels) {
        doc.addPage();
        addHeader(doc);
        addFooter(doc, doc.getNumberOfPages());

        const labelTrace = this.createLabelTrace(preparedData, label);
        const labelLayout = this.createLayoutForLabel(label);
        await Plotly.newPlot(plotDiv, [labelTrace as Plotly.Data], labelLayout, config);

        const labelImage = await Plotly.toImage(plotDiv, {
          format: 'jpeg',
          width: 2000,
          height: 1200,
        });

        doc.setFontSize(13);
        doc.setTextColor(0, 0, 128);
        doc.text(`${this.$t('ia.labelTrend')} ${label}`, margin, yOffset);

        doc.setLineWidth(0.5);
        doc.line(margin, yOffset + 3, pageWidth - margin, yOffset + 3);

        yOffset += 10;

        doc.addImage(labelImage, 'JPEG', margin, yOffset, pageWidth - 2 * margin, pageHeight - yOffset - 30);
      }

      // Conclusion
      doc.addPage();
      addHeader(doc);
      addFooter(doc, doc.getNumberOfPages());

      doc.setFontSize(14);
      doc.setTextColor(0, 0, 128);
      doc.text(this.$t('ia.conclusion').toString(), margin, 50);

      doc.setLineWidth(0.5);
      doc.line(margin, 53, pageWidth - margin, 53);

      doc.setFontSize(12);
      doc.text(this.$t('ia.activityConclusion').toString(), margin, 63, { maxWidth: pageWidth - 2 * margin });
    }

    // Finalisation du PDF
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    // Sauvegarde et téléchargement du PDF
    const fileName =
      this.modeSelected === 'Sécurité'
        ? `rapport-securite-${this.startDate}-${this.endDate}.pdf`
        : `rapport-activite-${this.startDate}-${this.endDate}.pdf`;
    doc.save(fileName);
  }

  private createActivityDensityTraces(data: { xData: Date[]; aggregatedData: any; categories: any[] }): Plotly.Data[] {
    const { xData, aggregatedData } = data;

    // Trace pour l'activité pondérée
    const weightedActivityTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['weightedActivity'],
      type: 'scatter',
      mode: 'lines',
      name: 'Activité',
      line: {
        color: '#d8ff00',
        width: 3,
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Activité: %{y}<extra></extra>',
    };

    // Trace pour la densité
    const densityTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['density'],
      type: 'scatter',
      mode: 'lines',
      name: 'Densité',
      line: {
        color: '#ff4d4d',
        width: 3,
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Densité: %{y}<extra></extra>',
    };

    // Trace pour le mouvement
    const movementTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['movement'],
      type: 'scatter',
      mode: 'lines',
      name: 'Mouvement',
      line: {
        color: '#ff4d4d',
        width: 3,
        shape: 'spline',
        smoothing: 0,
      },
      hovertemplate: 'Mouvement: %{y}<extra></extra>',
      yaxis: 'y2',
    };

    return [weightedActivityTrace, densityTrace, movementTrace] as Plotly.Data[];
  }

  private createLabelTrace(
    data: { xData: Date[]; aggregatedData: any; categories: any[] },
    label: string
  ): Partial<Plotly.PlotData> {
    const labelColors: { [key: string]: string } = {
      toupie: '#0DFF72',
      crane: '#00D2FF',
      nacelle: '#ff8915',
      pelle: '#d8ff5a',
      person: '#4dffcd',
      benne: '#FF007F',
      compacteuse: '#00FFCC',
      mobilecrane: '#AA00FF',
      camion: '#4e7bff',
      foreuse: '#33FF00',
      density: '#FF00B3',
      movement: '#3c7eff',
      helmet: '#ffffff',
      excavation: '#FF9900',
      filet: '#00FF00',
      gc: '#0000FF',
      heras: '#00FFFF',
      no_safety: '#FF0000',
      rubalise: '#FFD700',
      coactivity: '#FFA500',
      fire: '#ff0000',
      car: '#00BFFF',
    };
    return {
      x: data.xData,
      y: data.aggregatedData[label],
      type: 'bar',
      name: label,
      marker: {
        color: labelColors[label] || '#000000',
      }, // Now using 'label' to access the correct color
    };
  }

  private createLayoutForLabel(label: string): Partial<Plotly.Layout> {
    return {
      title: `Évolution du label : ${label}`,
      xaxis: {
        title: 'Date',
        type: 'date' as Plotly.AxisType,
      },
      yaxis: {
        title: 'Nombre',
      },
      bargap: 0.05,
      autosize: true,
      margin: { l: 50, r: 50, t: 50, b: 50 },
    };
  }

  private createPersonAndHelmetRatioGraph(data: { xData: Date[]; aggregatedData: any }): Plotly.Data[] {
    const { xData, aggregatedData } = data;

    // Barres des personnes
    const personBarTrace: Partial<Plotly.PlotData> = {
      x: xData,
      y: aggregatedData['person'], // Nombre de personnes détectées
      type: 'bar',
      name: 'Personnes',
      hovertemplate: 'Personnes: %{y}<extra></extra>',
      marker: {
        color: '#FFFF33', // Jaune fluo pour les personnes
      },
    };

    // Courbe du ratio casque/personne en pointillé
    const helmetPersonRatio = aggregatedData['person'].map((personCount: number, index: number) => {
      const helmetCount = aggregatedData['helmet'][index];
      const vestCount = aggregatedData['vest'][index];

      if (personCount > 0) {
        return ((helmetCount * 2 + vestCount) / (3 * personCount)) * 100;
      } else {
        // Lorsque aucune personne n'est détectée
        if (helmetCount > 0) {
          // Cas improbable où aucun individu n'est détecté mais des casques le sont
          return 100;
        } else {
          // Aucune personne et aucun casque détectés
          return 100;
        }
      }
    });

    const helmetPersonRatioTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: helmetPersonRatio,
      type: 'scatter',
      mode: 'lines',
      name: 'Ratio Casque/Personne',
      line: {
        color: '#FFA500', // Orange néon pour la courbe
        width: 2,
        dash: 'dash', // Ligne pointillée
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Sécurité EPI: %{y} %<extra></extra>',
      yaxis: 'y2', // Utiliser un axe secondaire
    };

    // Retourner les deux traces dans un tableau avec le bon typage
    return [personBarTrace, helmetPersonRatioTrace] as Plotly.Data[];
  }

  private createLayoutForPersonAndHelmetRatio() {
    return {
      barmode: 'stack',
      bargap: 0.05,
      modebar: {
        orientation: 'v',
        bgcolor: '#001a35',
        color: '#6c757d',
        activecolor: '#5fc9e4',
      },
      xaxis: {
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        type: 'date',
        tickformat: '%d/%m/%Y',
      },
      yaxis: {
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        title: {
          text: 'Nombre total de personnes',
        },
        anchor: 'x',
        domain: [0, 1],
      },
      yaxis2: {
        title: 'Port EPI (%)',
        overlaying: 'y',
        side: 'right',
        tickformat: '.2f',
        range: [0, 120],
        showgrid: false,
        color: 'cyan',
        anchor: 'x',
        domain: [0, 1],
      },
      autosize: true,
      margin: {
        l: 50,
        r: 100,
        b: 31,
        t: 10,
        pad: 0,
      },
      paper_bgcolor: 'white',
      plot_bgcolor: 'white',
      legend: {
        x: 0,
        xanchor: 'left' as const,
        y: 1.04,
        yanchor: 'middle' as const,
        orientation: 'h' as const,
        font: {
          color: '#5fc9e4',
        },
      },
    } as Partial<Plotly.Layout>;
  }

  private setDateRange(days: number): void {
    this.updatingFromDateRange = true;
    this.selectedRange = days.toString(); // Met à jour la variable pour montrer le bouton actif
    if (this.lastPhotoDate) {
      const startDate = new Date(this.lastPhotoDate);
      startDate.setDate(startDate.getDate() - days);
      this.startDate = this.formatDateForInput(startDate);

      // Ajuster la date de fin pour inclure toute la journée
      const endDate = new Date(this.lastPhotoDate);
      endDate.setHours(23, 59, 59, 999);
      this.endDate = this.formatDateForInput(endDate);

      if (this.modeSelected === 'Sécurité') {
        this.createSecurityChart();
      } else {
        this.createChart();
      }
    }
    this.updatingFromDateRange = false;
  }

  private resetButtonSelection(): void {
    this.selectedRange = null;
  }

  private async loadBoundingBoxImages(selectedPhoto: Photo): Promise<void> {
    if (!selectedPhoto?.key) {
      console.warn('Pas de photo sélectionnée');
      return;
    }

    let photoKey = selectedPhoto.key;
    if (photoKey.startsWith('public/')) {
      photoKey = photoKey.substring('public/'.length);
    }
    const baseName = photoKey.split('/').pop()!.split('.')[0];
    const directory = photoKey.substring(0, photoKey.lastIndexOf('/'));

    try {
      let allFiles: { key: string }[] = [];

      if (this.modeSelected === 'Sécurité') {
        // Lister à la fois Segmentation ET coactivity
        const segFolder = `${directory}/IA/${baseName}/Segmentation/`;
        const coactivityFolder = `${directory}/IA/${baseName}/coactivity/`;

        const segFiles = (await Storage.list(segFolder, { level: 'public' })) as any[];
        const coactivityFiles = (await Storage.list(coactivityFolder, { level: 'public' })) as any[];

        // Taguer la provenance (Segmentation ou Coactivity)
        allFiles = [
          ...segFiles.map((f) => ({ ...f, _type: 'segmentation' })),
          ...coactivityFiles.map((f) => ({ ...f, _type: 'coactivity' })),
        ];
      } else {
        // Mode Détection = tout sauf Segmentation et Coactivity
        const iaFolder = `${directory}/IA/${baseName}/`;
        const iaFiles = (await Storage.list(iaFolder, { level: 'public' })) as any[];
        allFiles = iaFiles.filter((f) => !f.key.includes('/Segmentation/') && !f.key.includes('/coactivity/'));
      }

      // Préparer le mapping label
      const labelMap: { [key: string]: string } = {
        background: 'Compacteuse',
        helmet: 'Casque',
        vest: 'Gilet',
        Person: 'Personne',
        gruemobile: 'Grue mobile',
        crane: 'Grue à tour',
        camion: 'Camion',
        pelle: 'Pelle',
        chariot: 'Chariot',
        nacelle: 'Nacelle',
        toupie: 'Toupie',
        benne: 'Benne',
        goutte: 'Goutte',
        foreuse: 'Foreuse',
        no_safety: 'Non sécurisé',
        coactivity: 'Coactivité',
        fire: 'Feu',
        Smoke: 'Fumée',
        Bonfire: 'Feu',
        Car: 'Voiture',
      };

      // Charger les URLs et parser label/confidence
      const images: BoundingBoxImage[] = await Promise.all(
        allFiles.map(async (file) => {
          const url = (await Storage.get(file.key, { level: 'public' })) as string;
          const filename = file.key
            .split('/')
            .pop()!
            .replace(/\.[^.]+$/, '');

          if ((file as any)._type === 'coactivity') {
            // Ex: coactivity-p0-egruemobile-1
            const parts = filename.split('-');
            // parts[1] => p0 (= personne 0), parts[2] => egruemobile (= engin grue mobile), parts[3] => n° éventuel
            const personLabel = 'Personne';
            // Retirer le préfixe éventuel 'e' sur l’engin (egruemobile => gruemobile)
            let enginKey = parts[2];
            if (enginKey.startsWith('e')) enginKey = enginKey.slice(1);
            const enginLabel = labelMap[enginKey] || enginKey;
            const label = `Coactivité : ${personLabel} & ${enginLabel}`;
            return { url, label, confidence: '', key: file.key };
          } else {
            // Segmentation ou IA standard
            const nameParts = filename.split('-');
            const rawLabel = nameParts[nameParts.length - 2];
            const confidence = nameParts[nameParts.length - 1];
            const label = labelMap[rawLabel] || rawLabel;
            return { url, label, confidence, key: file.key };
          }
        })
      );

      this.boundingBoxImages = images;
    } catch (err) {
      console.error('Erreur chargement IA images :', err);
    }
  }

  private createChart() {
    // Vérifier que this.originalData est initialisé
    if (!this.originalData || this.originalData.length === 0) {
      console.warn('Aucune donnée disponible pour le graphique.');
      return;
    }

    // Copier les données originales pour le filtrage
    let data = [...this.originalData];

    // Filtrer les données en fonction des dates sélectionnées
    if (this.startDate) {
      const start = new Date(this.startDate);
      data = data.filter((d) => d.date >= start);
    }

    if (this.endDate) {
      const end = new Date(this.endDate);
      // Ajuster la date de fin pour inclure toute la journée
      end.setHours(23, 59, 59, 999);
      data = data.filter((d) => d.date <= end);
    }

    this.chartReady = true;
    this.chartInitialized = true;
    // S'assurer que l'élément DOM existe avant d'appeler updateChart
    this.$nextTick(() => {
      const plotDiv: any = document.getElementById('chart');
      if (!plotDiv) {
        console.error("L'élément #chart n'est pas présent dans le DOM.");
        return;
      }
      this.updateChart(data);
    });
  }

  private createSecurityChart(): void {
    if (!this.originalData?.length) {
      console.warn('Aucune donnée disponible pour le graphique de sécurité.');
      return;
    }

    // 1) Filtrer / préparer …
    const filteredData = this.filterDataByDates(this.originalData);
    const prepared = this.prepareSecurityData(filteredData);
    const { xData, aggregatedData, categories } = prepared;

    // 2) Construire traces, layout et config
    const traces = this.createSecurityTraces(prepared);
    const layout = this.createSecurityLayout();
    const config = this.createConfig();

    // 3) Récupérer la div
    const plotDiv: any = document.getElementById('chart');
    if (!plotDiv) {
      console.error("L'élément #chart n'est pas présent dans le DOM.");
      return;
    }

    // fonction utilitaire pour attacher le handler de zoom **à chaque fois**
    const attachRelayout = () => {
      plotDiv.removeAllListeners?.('plotly_relayout');
      plotDiv.on('plotly_relayout', (eventData: any) => {
        if (eventData['xaxis.range[0]'] && eventData['xaxis.range[1]']) {
          let newStart = new Date(eventData['xaxis.range[0]']);
          let newEnd = new Date(eventData['xaxis.range[1]']);

          // Get the min and max dates from the original data
          const minDate = new Date(Math.min(...this.originalData.map((d) => d.date.getTime())));
          const maxDate = new Date(Math.max(...this.originalData.map((d) => d.date.getTime())));

          // Add padding to maxDate to ensure the last points are visible
          const paddingMs = 24 * 60 * 60 * 1000; // 1 day padding
          const paddedMaxDate = new Date(maxDate.getTime() + paddingMs);

          // If zooming near the right edge, extend the range to include the last data point
          if (newEnd.getTime() >= maxDate.getTime() - paddingMs) {
            newEnd = paddedMaxDate;
          }

          // Ensure the start date is not before the min date
          if (newStart < minDate) {
            newStart = minDate;
          }

          // Update dates and redraw chart
          this.updatingFromChart = true;
          this.startDate = this.formatDateWithTime(newStart);
          this.endDate = this.formatDateWithTime(newEnd);
          this.updatingFromChart = false;

          this.isChartInitialized = false;
          this.createSecurityChart();
        } else if (eventData['xaxis.autorange']) {
          this.resetToOriginalDates();
          this.isChartInitialized = false;
          this.createSecurityChart();
        }
      });
    };

    const bindClick = () => {
      plotDiv.on('plotly_click', this.handleChartClick.bind(this));
    };

    if (!this.isChartInitialized) {
      Plotly.newPlot(plotDiv, traces, layout, config).then(() => {
        this.isChartInitialized = true;
        attachRelayout();
        bindClick(); // ← on ajoute le click ici
        this.calculateSecurityScores(prepared);
      });
    } else {
      Plotly.react(plotDiv, traces, layout, config).then(() => {
        attachRelayout();
        bindClick(); // ← et aussi ici après react
        this.calculateSecurityScores(prepared);
      });
    }
  }

  private filterDataByDates(data: any[]) {
    let d = [...data];
    if (this.startDate) {
      const s = new Date(this.startDate);
      d = d.filter((p) => p.date >= s);
    }
    if (this.endDate) {
      const e = new Date(this.endDate);
      e.setHours(23, 59, 59, 999);
      d = d.filter((p) => p.date <= e);
    }
    return d;
  }

  private async updateChart(data: any[]) {
    const preparedData = this.prepareData(data); // Préparer les données pour le graphique
    const traces = this.createTraces(preparedData, true);
    const layout = this.createLayout();
    const config = this.createConfig();

    const plotDiv: any = document.getElementById('chart');
    const hoverInfoDiv = document.getElementById('hoverinfo');

    if (!this.isChartInitialized) {
      await Plotly.newPlot(plotDiv, traces, layout, config);
      this.isChartInitialized = true;

      // Ajout du gestionnaire d'événements 'plotly_click'
      plotDiv.on('plotly_click', this.handleChartClick.bind(this));

      plotDiv.on('plotly_relayout', (eventData: Plotly.PlotRelayoutEvent) => {
        // Vérification si l'utilisateur a sélectionné une nouvelle plage de dates
        if (eventData['xaxis.range[0]'] && eventData['xaxis.range[1]']) {
          const newStartDate = new Date(eventData['xaxis.range[0]']);
          const newEndDate = new Date(eventData['xaxis.range[1]']);

          // Vérifier si les dates sélectionnées se trouvent le même jour
          const isSameDay = newStartDate.toDateString() === newEndDate.toDateString();

          if (isSameDay) {
            // Lorsque les deux dates sont le même jour, vérifier que la plage horaire est valide
            if (newStartDate < newEndDate) {
              // Mettre à jour les plages avec la sélection de plage horaire valide
              this.updatingFromChart = true;
              this.startDate = this.formatDateWithTime(newStartDate);
              this.endDate = this.formatDateWithTime(newEndDate);
              this.updatingFromChart = false;
            } else {
              // Si les dates ou les heures sont invalides, restaurer les dates originales
              this.resetToOriginalDates();
            }
          } else if (newStartDate < newEndDate) {
            // Si les dates sélectionnées couvrent plusieurs jours
            this.updatingFromChart = true;
            this.startDate = this.formatDateWithTime(newStartDate);
            this.endDate = this.formatDateWithTime(newEndDate);
            this.updatingFromChart = false;
          } else {
            // Si la sélection est incorrecte, restaurer les dates originales
            this.resetToOriginalDates();
          }
        } else if (eventData['xaxis.autorange']) {
          // Réinitialiser la plage de dates si l'utilisateur réinitialise le zoom
          this.resetToOriginalDates();
        }
      });

      plotDiv.on('plotly_hover', (data: any) => {
        const infotext = data.points.map((d: any) => {
          return `<img src="${d.customdata}" style="height: 100px; width: auto;">`;
        });
        this.hoverInfoPosition.x = data.event.clientX;
        this.hoverInfoPosition.y = data.event.clientY;
        if (hoverInfoDiv) {
          hoverInfoDiv.innerHTML = infotext.join('');
        }
      });

      plotDiv.on('plotly_unhover', function () {
        if (hoverInfoDiv) {
          hoverInfoDiv.innerHTML = '';
        }
      });

      plotDiv.on('mousemove', function (e: any) {
        if (hoverInfoDiv) {
          hoverInfoDiv.style.left = `${e.clientX}px`;
          hoverInfoDiv.style.top = `${e.clientY}px`;
        }
      });
      this.addPlotlyEventHandlers(plotDiv, hoverInfoDiv);
    } else {
      await Plotly.react(plotDiv, traces, layout, config);
    }

    // Calculer la moyenne de la deuxième moitié des données visibles
    this.calculateSecondHalfAverage(preparedData);
  }

  private resetToOriginalDates() {
    if (this.firstPhotoDate && this.lastPhotoDate) {
      this.updatingFromChart = true;
      this.startDate = this.formatDateForInput(this.firstPhotoDate);
      this.endDate = this.formatDateForInput(this.lastPhotoDate);
      this.updatingFromChart = false;
    }
  }

  private addPlotlyEventHandlers(plotDiv: any, hoverInfoDiv: any) {
    plotDiv.on('plotly_click', this.handleChartClick.bind(this));

    plotDiv.on('plotly_relayout', (eventData: Plotly.PlotRelayoutEvent) => {
      // Votre logique actuelle pour relayout
    });

    plotDiv.on('plotly_hover', (data: any) => {
      const infotext = data.points.map((d: any) => `<img src="${d.customdata}" style="height: 100px; width: auto;">`);
      this.hoverInfoPosition.x = data.event.clientX;
      this.hoverInfoPosition.y = data.event.clientY;
      if (hoverInfoDiv) {
        hoverInfoDiv.innerHTML = infotext.join('');
      }
    });

    plotDiv.on('plotly_unhover', () => {
      if (hoverInfoDiv) {
        hoverInfoDiv.innerHTML = '';
      }
    });

    plotDiv.on('mousemove', (e: any) => {
      if (hoverInfoDiv) {
        hoverInfoDiv.style.left = `${e.clientX}px`;
        hoverInfoDiv.style.top = `${e.clientY}px`;
      }
    });
  }

  private formatDateWithTime(date: Date) {
    // Formater la date avec heure pour les inputs date+time HTML
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  private calculateSecondHalfAverage(preparedData: any) {
    const { xData, aggregatedData, categories } = preparedData;

    // Obtenir la seconde moitié des indices visibles
    const halfIndex = Math.floor(xData.length / 2);
    const secondHalfXData = xData.slice(halfIndex);
    const secondHalfYData = secondHalfXData.map((_: any, index: number) => {
      return categories.reduce((sum: number, { key }: { key: string }) => {
        return sum + aggregatedData[key][halfIndex + index];
      }, 0);
    });

    // Calculer la moyenne de la seconde moitié
    if (secondHalfYData.length > 0) {
      const total = secondHalfYData.reduce((acc: number, value: number) => acc + value, 0);
      const average = total / secondHalfYData.length;
      this.lastActivityScore = average; // Mettre à jour le score affiché
    }

    // Calculer la moyenne pour la moitié gauche
    const firstHalfXData = xData.slice(0, halfIndex);
    const firstHalfYData = firstHalfXData.map((_: any, index: number) => {
      return categories.reduce((sum: number, { key }: { key: string }) => {
        return sum + aggregatedData[key][index];
      }, 0);
    });

    if (firstHalfYData.length > 0) {
      const total = firstHalfYData.reduce((acc: number, value: number) => acc + value, 0);
      const average = total / firstHalfYData.length;
      this.leftActivityScore = average; // Score de la moitié gauche
    }

    // Calcul pour la moyenne des personnes détectées
    const secondHalfPersonData = aggregatedData['person'].slice(halfIndex);
    if (secondHalfPersonData.length > 0) {
      const total = secondHalfPersonData.reduce((acc: number, value: number) => acc + value, 0);
      this.lastPersonScore = total / secondHalfPersonData.length;
    }

    // Calcul de la première moitié pour les personnes détectées
    const firstHalfPersonData = aggregatedData['person'].slice(0, halfIndex);
    if (firstHalfPersonData.length > 0) {
      const total = firstHalfPersonData.reduce((acc: number, value: number) => acc + value, 0);
      this.leftPersonScore = total / firstHalfPersonData.length;
    }

    const secondHalfDensityData = aggregatedData['density'].slice(halfIndex);
    if (secondHalfDensityData.length > 0) {
      const total = secondHalfDensityData.reduce((acc: number, value: number) => acc + value, 0);
      this.lastDensityScore = total / secondHalfDensityData.length;
    }

    const firstHalfDensityData = aggregatedData['density'].slice(0, halfIndex);
    if (firstHalfDensityData.length > 0) {
      const total = firstHalfDensityData.reduce((acc: number, value: number) => acc + value, 0);
      this.leftDensityScore = total / firstHalfDensityData.length;
    }

    // Initialisation des scores de sécurité EPI à 100%
    this.lastHelmetScore = 100;
    this.leftHelmetScore = 100;

    // Calcul pour la seconde moitié
    const secondHalfHelmetData = aggregatedData['helmet'].slice(halfIndex);
    const secondHalfVestData = aggregatedData['vest'].slice(halfIndex);
    const totalHelmets = secondHalfHelmetData.reduce((acc: number, value: number) => acc + value, 0);
    const totalVests = secondHalfVestData.reduce((acc: number, value: number) => acc + value, 0);
    const totalPersons = aggregatedData['person']
      .slice(halfIndex)
      .reduce((acc: number, value: number) => acc + value, 0);

    if (totalPersons > 0) {
      this.lastHelmetScore = ((2 * totalHelmets + totalVests) / (3 * totalPersons)) * 100;
    } else {
      this.lastHelmetScore = 100;
    }

    // Calcul pour la première moitié
    const firstHalfHelmetData = aggregatedData['helmet'].slice(0, halfIndex);
    const firstHalfVestData = aggregatedData['vest'].slice(0, halfIndex);
    const totalHelmetsLeft = firstHalfHelmetData.reduce((acc: number, value: number) => acc + value, 0);
    const totalVestsLeft = firstHalfVestData.reduce((acc: number, value: number) => acc + value, 0);
    const totalPersonsLeft = aggregatedData['person']
      .slice(0, halfIndex)
      .reduce((acc: number, value: number) => acc + value, 0);

    if (totalPersonsLeft > 0) {
      this.leftHelmetScore = ((2 * totalHelmetsLeft + totalVestsLeft) / (3 * totalPersonsLeft)) * 100;
    } else {
      this.leftHelmetScore = 100;
    }
  }

  private calculateSecurityScores(prepared: { xData: Date[]; aggregatedData: Record<string, number[]> }) {
    const { xData, aggregatedData } = prepared;
    const halfIndex = Math.floor(xData.length / 2);

    // Calcul pour no_safety
    const noSafetyArr: number[] = aggregatedData['no_safety'] || [];
    const noSafetyFirstHalf = noSafetyArr.slice(0, halfIndex);
    const noSafetySecondHalf = noSafetyArr.slice(halfIndex);

    this.leftNosafetyScore = noSafetyFirstHalf.length
      ? noSafetyFirstHalf.reduce((a, b) => a + b, 0) / noSafetyFirstHalf.length
      : null;

    this.lastNosafetyScore = noSafetySecondHalf.length
      ? noSafetySecondHalf.reduce((a, b) => a + b, 0) / noSafetySecondHalf.length
      : null;

    // Calcul pour fire
    const fireArr: number[] = aggregatedData['fire'] || [];
    const fireFirstHalf = fireArr.slice(0, halfIndex);
    const fireSecondHalf = fireArr.slice(halfIndex);

    this.leftFireScore = fireFirstHalf.length ? fireFirstHalf.reduce((a, b) => a + b, 0) : null;

    this.lastFireScore = fireSecondHalf.length ? fireSecondHalf.reduce((a, b) => a + b, 0) : null;

    // Calcul pour car
    const carArr: number[] = aggregatedData['car'] || [];
    const carFirstHalf = carArr.slice(0, halfIndex);
    const carSecondHalf = carArr.slice(halfIndex);

    this.leftCarScore = carFirstHalf.length ? carFirstHalf.reduce((a, b) => a + b, 0) : null;

    this.lastCarScore = carSecondHalf.length ? carSecondHalf.reduce((a, b) => a + b, 0) : null;

    // Calcul pour coactivity
    const coactivityArr: number[] = aggregatedData['coactivity'] || [];
    const coactivityFirstHalf = coactivityArr.slice(0, halfIndex);
    const coactivitySecondHalf = coactivityArr.slice(halfIndex);

    this.leftCoactivityScore = coactivityFirstHalf.length
      ? coactivityFirstHalf.reduce((a, b) => a + b, 0) / coactivityFirstHalf.length
      : null;

    this.lastCoactivityScore = coactivitySecondHalf.length
      ? coactivitySecondHalf.reduce((a, b) => a + b, 0) / coactivitySecondHalf.length
      : null;
  }

  private prepareData(data: any[]) {
    const xRange = [
      this.startDate ? new Date(this.startDate).getTime() : data[0].date.getTime(),
      this.endDate ? new Date(this.endDate).getTime() : data[data.length - 1].date.getTime(),
    ];

    // Filtrer les données en fonction de la plage visible
    const filteredData = data.filter((d) => {
      const time = d.date.getTime();
      return time >= xRange[0] && time <= xRange[1];
    });

    const dataPointCount = filteredData.length;

    // Calcul de la durée de la plage visible (en millisecondes)
    const rangeDuration = xRange[1] - xRange[0];
    const dayDuration = 24 * 60 * 60 * 1000; // Durée d'un jour en millisecondes
    const weekDuration = 7 * dayDuration; // Durée d'une semaine en millisecondes

    // Seuils pour les différents niveaux d'agrégation
    const shouldAggregateByWeek = rangeDuration > 15 * weekDuration; // Agrégation par semaine si plage > 15 semaines
    const shouldAggregateByDay = rangeDuration > 7 * dayDuration && !shouldAggregateByWeek; // Agrégation par jour si > 7 jours

    let xData: Date[] = [];
    let aggregatedData: { [key: string]: number[] } = {};
    type Category = {
      key: string;
      label: string;
    };

    let categories: Category[];
    if (this.modeSelected === 'Sécurité') {
      categories = [
        { key: 'no_safety', label: 'Non sécurisé' },
        { key: 'fire', label: 'Feu' },
        { key: 'coactivity', label: 'Coactivité' },
        { key: 'car', label: 'Voiture' },
      ];
    } else {
      // mode Détection
      categories = [
        { key: 'toupie', label: 'timelapseedition.toupie' },
        { key: 'crane', label: 'timelapseedition.crane' },
        { key: 'nacelle', label: 'timelapseedition.nacelle' },
        { key: 'pelle', label: 'timelapseedition.pelle' },
        { key: 'person', label: 'timelapseedition.person' },
        { key: 'benne', label: 'timelapseedition.benne' },
        { key: 'compacteuse', label: 'timelapseedition.compacteuse' },
        { key: 'mobilecrane', label: 'timelapseedition.mobilecrane' },
        { key: 'camion', label: 'timelapseedition.camion' },
        { key: 'foreuse', label: 'timelapseedition.foreuse' },
        { key: 'density', label: 'Densité' },
        { key: 'movement', label: 'Mouvement' },
        { key: 'helmet', label: 'Casque' },
        { key: 'vest', label: 'Gilet' },
        // PAS de fire, car, no_safety ni coactivity ici !
      ];
    }

    if (dataPointCount <= 2) {
      // Toujours utiliser les données non agrégées si 2 points ou moins
      xData = filteredData.map((d) => d.date);
      aggregatedData = {};
      categories.forEach((category: Category) => {
        aggregatedData[category.key] = filteredData.map((d) => d[category.key]);
      });
    } else if (shouldAggregateByWeek) {
      // Agrégation par semaine
      const groupedData = d3Array.groups(filteredData, (d) => d3.timeWeek(d.date));

      xData = [];
      aggregatedData = {};
      categories.forEach((category: Category) => {
        aggregatedData[category.key] = [];
      });

      groupedData.forEach(([dateStr, items]) => {
        const date = new Date(dateStr);
        xData.push(date);

        categories.forEach((category: Category) => {
          const total = items.reduce((sum, d) => sum + d[category.key], 0) / items.length;
          aggregatedData[category.key].push(total);
        });
      });
    } else if (shouldAggregateByDay) {
      // Agrégation par jour
      const groupedData = d3Array.groups(filteredData, (d) => d3.timeDay(d.date));

      xData = [];
      aggregatedData = {};
      categories.forEach((category: Category) => {
        aggregatedData[category.key] = [];
      });

      groupedData.forEach(([dateStr, items]) => {
        const date = new Date(dateStr);
        xData.push(date);

        categories.forEach((category: Category) => {
          const total = items.reduce((sum, d) => sum + d[category.key], 0) / items.length;
          aggregatedData[category.key].push(total);
        });
      });
    } else {
      // Afficher chaque point sans agrégation
      xData = filteredData.map((d) => d.date);
      aggregatedData = {};
      categories.forEach((category: Category) => {
        aggregatedData[category.key] = filteredData.map((d) => d[category.key]);
      });
    }

    // **Calcul de weightedActivity**
    const labelWeights = {
      toupie: 2.0,
      crane: 1.0,
      nacelle: 1.5,
      pelle: 1.5,
      person: 1.0,
      benne: 0.3,
      compacteuse: 1.5,
      mobilecrane: 2.5,
      camion: 1.8,
      helmet: 0.0,
    };

    const weightedActivity = xData.map((_, index) => {
      return categories.reduce((sum: number, category: Category) => {
        const key = category.key;
        const weight = labelWeights[key as keyof typeof labelWeights] || 1;
        return sum + (aggregatedData[key][index] * weight) / 2;
      }, 0);
    });

    aggregatedData['weightedActivity'] = weightedActivity;

    return { xData, aggregatedData, categories };
  }

  private prepareSecurityData(data: any[]) {
    const xRange = [
      this.startDate ? new Date(this.startDate).getTime() : data[0].date.getTime(),
      this.endDate ? new Date(this.endDate).getTime() : data[data.length - 1].date.getTime(),
    ];

    // Filtrer les données en fonction de la plage visible
    const filteredData = data.filter((d) => {
      const time = d.date.getTime();
      return time >= xRange[0] && time <= xRange[1];
    });

    const dataPointCount = filteredData.length;

    // Calcul de la durée de la plage visible (en millisecondes)
    const rangeDuration = xRange[1] - xRange[0];
    const dayDuration = 24 * 60 * 60 * 1000;
    const weekDuration = 7 * dayDuration;

    // Définir les catégories à afficher
    const categories = [
      { key: 'excavation', label: 'Excavation' },
      { key: 'filet', label: 'Filet' },
      { key: 'gc', label: 'Garde-corps' },
      { key: 'heras', label: 'Heras' },
      { key: 'no_safety', label: 'Non sécurisé' },
      { key: 'rubalise', label: 'Rubalise' },
      { key: 'coactivity', label: 'Coactivité' },
      { key: 'fire', label: 'Feu' },
      { key: 'car', label: 'Voiture' },
    ];

    let xData: Date[] = [];
    let aggregatedData: { [key: string]: number[] } = {};

    // Agrégation selon la plage de temps
    if (dataPointCount <= 2) {
      // Pas d'agrégation si peu de points
      xData = filteredData.map((d) => d.date);
      aggregatedData = {};
      categories.forEach((category) => {
        aggregatedData[category.key] = filteredData.map((d) => d[category.key] || 0);
      });
    } else if (rangeDuration > 15 * weekDuration) {
      // Agrégation par semaine
      const groupedData = d3Array.groups(filteredData, (d) => d3.timeWeek(d.date));
      xData = [];
      aggregatedData = {};
      categories.forEach((category) => {
        aggregatedData[category.key] = [];
      });

      groupedData.forEach(([dateStr, items]) => {
        const date = new Date(dateStr);
        xData.push(date);
        categories.forEach((category) => {
          const total = items.reduce((sum, d) => sum + (d[category.key] || 0), 0);
          aggregatedData[category.key].push(total);
        });
      });
    } else if (rangeDuration > 7 * dayDuration) {
      // Agrégation par jour
      const groupedData = d3Array.groups(filteredData, (d) => d3.timeDay(d.date));
      xData = [];
      aggregatedData = {};
      categories.forEach((category) => {
        aggregatedData[category.key] = [];
      });

      groupedData.forEach(([dateStr, items]) => {
        const date = new Date(dateStr);
        xData.push(date);
        categories.forEach((category) => {
          const total = items.reduce((sum, d) => sum + (d[category.key] || 0), 0);
          aggregatedData[category.key].push(total);
        });
      });
    } else {
      // Pas d'agrégation
      xData = filteredData.map((d) => d.date);
      aggregatedData = {};
      categories.forEach((category) => {
        aggregatedData[category.key] = filteredData.map((d) => d[category.key] || 0);
      });
    }

    return { xData, aggregatedData, categories };
  }

  private createSecurityTraces(data: { xData: Date[]; aggregatedData: any; categories: any[] }): Plotly.Data[] {
    const { xData, aggregatedData, categories } = data;

    // Définir les couleurs pour chaque catégorie
    const labelColors: { [key: string]: string } = {
      excavation: '#FF9900',
      filet: '#00FF00',
      gc: '#0000FF',
      heras: '#00FFFF',
      no_safety: '#FF0000',
      rubalise: '#FFD700',
      coactivity: '#FFA500',
      fire: '#ff0000',
      car: '#00BFFF',
    };

    // Créer une trace pour chaque catégorie
    const traces = categories
      .filter(
        ({ key }) =>
          (key === 'no_safety' || key === 'coactivity' || key === 'fire' || key === 'car') &&
          this.hasNonZeroValues(aggregatedData[key])
      )
      .map(({ key, label }) => {
        const yData = aggregatedData[key];
        const textData = yData.map((value: number, index: number) => {
          return `${label}: ${value.toFixed(1)}<br>${d3.timeFormat('%d/%m/%Y %H:%M:%S')(xData[index])}`;
        });
        const customData = xData.map((date) => this.getPhotoIdsForDate(date));

        return {
          x: xData,
          y: yData,
          type: 'bar',
          name: label,
          text: textData,
          hovertemplate: '%{text}<extra></extra>',
          marker: {
            color: labelColors[key] || '#000000',
          },
          customdata: customData,
        } as Partial<Plotly.PlotData>;
      });

    return traces as Plotly.Data[];
  }

  private createSecurityLayout(): Partial<Plotly.Layout> {
    return {
      barmode: 'stack', // Empiler les barres
      bargap: 0.05,
      modebar: {
        orientation: 'v',
        bgcolor: '#001a35',
        color: '#6c757d',
        activecolor: '#5fc9e4',
      },
      xaxis: {
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        type: 'date',
        tickformat: '%d/%m/%Y',
        autorange: true,
        rangemode: 'tozero', // Ensures the range starts from the earliest data point
        tickmode: 'auto', // Let Plotly handle tick placement
        nticks: 10, // Suggest a reasonable number of ticks to avoid clutter
        showgrid: true, // Optional: Show grid for better visibility
        automargin: true,
      },
      yaxis: {
        autorange: true,
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        title: {
          text: 'Occurrences',
          standoff: 100,
        },
        anchor: 'x',
      },
      margin: {
        l: 50,
        r: 80,
        b: 31,
        t: 10,
        pad: 0,
      },
      paper_bgcolor: 'transparent',
      plot_bgcolor: 'transparent',
      legend: {
        x: 0,
        xanchor: 'left',
        y: 1.04,
        yanchor: 'middle',
        orientation: 'h',
        font: {
          color: '#5fc9e4',
        },
      },
    };
  }

  private hasNonZeroValues(dataArray: number[]): boolean {
    return dataArray.some((value) => value !== 0);
  }

  private createTraces(
    data: { xData: Date[]; aggregatedData: any; categories: any[] },
    includeBars = true
  ): Plotly.Data[] {
    const labelColors: { [key: string]: string } = {
      toupie: '#0DFF72',
      crane: '#00D2FF',
      nacelle: '#ff8915',
      pelle: '#d8ff5a',
      person: '#4dffcd',
      benne: '#FF007F',
      compacteuse: '#00FFCC',
      mobilecrane: '#AA00FF',
      camion: '#4e7bff',
      foreuse: '#33FF00',
      density: '#FF00B3',
      movement: '#3c7eff',
      helmet: '#ffffff',
    };
    const labelWeights = {
      toupie: 2.0,
      crane: 1.0,
      nacelle: 1.5,
      pelle: 1.5,
      person: 1.0,
      benne: 0.3,
      compacteuse: 1.5,
      mobilecrane: 2.5,
      camion: 1.8,
      helmet: 0.0,
    };

    const { xData, aggregatedData, categories } = data;

    // Créer une trace pour l'activité globale pondérée
    const weightedActivity = xData.map((_, index) => {
      return categories.reduce((sum, { key }) => {
        const weight = labelWeights[key as keyof typeof labelWeights] || 1; // Utiliser 1 si aucun poids n'est défini pour ce label
        return sum + (aggregatedData[key][index] * weight) / 2;
      }, 0);
    });

    this.lastActivityScore = weightedActivity[weightedActivity.length - 1];

    const weightedActivityTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: weightedActivity,
      type: 'scatter',
      mode: 'lines',
      //fill: 'tozeroy',
      //fillcolor: 'rgba(77, 255, 205, 0.2)',
      name: 'Activité',
      line: {
        color: '#d8ff00',
        width: 3,
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Activité: %{y}<extra></extra>',
    };

    // Tracé pour la densité
    const densityTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['density'],
      type: 'scatter',
      mode: 'lines',
      name: 'Densité',
      line: {
        color: '#ff9e03',
        width: 3,
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Densité: %{y}<extra></extra>',
    };

    const movementTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: aggregatedData['movement'],
      type: 'scatter',
      mode: 'lines',
      name: 'Mouvement',
      line: {
        color: '#3c7eff',
        width: 3,
        shape: 'spline',
      },
      hovertemplate: 'Mouvement: %{y}<extra></extra>',
      yaxis: 'y2',
    };

    // Courbe pour le ratio casque/personne
    const helmetPersonRatio = aggregatedData['person'].map((personCount: number, index: number) => {
      const helmetCount = aggregatedData['helmet'][index];
      const vestCount = aggregatedData['vest'][index];

      if (personCount > 0) {
        return ((helmetCount * 2 + vestCount) / (3 * personCount)) * 100;
      } else {
        // Lorsque aucune personne n'est détectée
        if (helmetCount > 0) {
          // Cas improbable où aucun individu n'est détecté mais des casques le sont
          return 100;
        } else {
          // Aucune personne et aucun casque détectés
          return 100;
        }
      }
    });

    const helmetPersonRatioTrace: Partial<Plotly.ScatterData> = {
      x: xData,
      y: helmetPersonRatio,
      type: 'scatter',
      mode: 'lines',
      name: 'Port EPI',
      line: {
        color: 'cyan',
        width: 3,
        dash: 'dashdot',
        shape: 'spline',
        smoothing: 0.5,
      },
      hovertemplate: 'Sécurité EPI: %{y} %<extra></extra>',
      yaxis: 'y2', // Ajouter sur l'axe y2 (si vous avez déjà un axe secondaire)
    };

    const traces = [weightedActivityTrace, densityTrace, movementTrace, helmetPersonRatioTrace];

    // Ajouter les barres des détections seulement si includeBars est vrai
    if (includeBars) {
      const detectionTraces = categories
        .filter(
          ({ key }) =>
            key !== 'density' &&
            key !== 'movement' &&
            key !== 'no_safety' &&
            key !== 'coactivity' &&
            this.hasNonZeroValues(aggregatedData[key])
        )
        .map(({ key, label }) => {
          const yData = aggregatedData[key];
          const textData = yData.map((value: number, index: number) => {
            return `${this.$t(label)}: ${value}<br>${d3.timeFormat('%d/%m/%Y %H:%M:%S')(xData[index])}`;
          });
          const customData = data.xData.map((date) => this.getPhotoIdsForDate(date));
          return {
            x: xData as Date[],
            y: yData,
            type: 'bar',
            name: this.$t(label) as string,
            text: textData,
            hovertemplate: '%{text}<extra></extra>',
            marker: {
              color: labelColors[key] || '#000000',
            },
            customdata: customData, // Ligne problématique
          } as Partial<Plotly.PlotData>;
        });

      traces.push(...detectionTraces);
    }

    return traces;
  }

  private getPhotoIdsForDate(date: Date): string[] {
    const photoIds = this.originalData
      .filter((d) => d.date.toDateString() === date.toDateString())
      .map((d) => d.photoId);
    return photoIds;
  }

  private extractS3KeyFromUrl(url: string): string | null {
    // Prend tout après ".com/" jusqu'au "?" (ou fin)
    const match = url.match(/\.com\/([^?]+)/);
    return match ? match[1] : null;
  }

  private async reportFalseDetectionroboflow(index: number) {
    const falseDetection = this.boundingBoxImages[index];
    console.log('False detection', falseDetection);
    try {
      // Récupérer l’URL publique de l’image depuis S3
      const imageUrl = await Storage.get(falseDetection.key, { level: 'public' });
      // Télécharger l’image et la convertir en Blob
      const response = await fetch(imageUrl as string);
      const blob = await response.blob();

      // Créer un FormData pour l’envoi vers Roboflow
      const formData = new FormData();
      // On génère un nom de fichier basé sur l’heure et le label (à adapter selon vos besoins)
      const fileName = `reported-${Date.now()}-${falseDetection.label}.jpg`;
      formData.append('name', fileName);
      formData.append('file', blob, fileName);
      // On peut indiquer le split (par exemple "train")
      formData.append('split', 'train');

      // Configuration de Roboflow : remplacez par vos informations
      const ROBOFLOW_API_KEY = 'sMvFYAUEXICXjfJaPDAs';
      const ROBOFLOW_DATASET = 'erige';

      // Envoyer l'image à Roboflow via axios
      const axiosResponse = await axios.post(`https://api.roboflow.com/dataset/${ROBOFLOW_DATASET}/upload`, formData, {
        params: {
          api_key: ROBOFLOW_API_KEY,
        },
      });

      // === SUPPRESSION S3 ===
      let s3Key = falseDetection.key;
      if (!s3Key.startsWith('public/')) {
        s3Key = 'public/' + s3Key;
      }
      // Extraction photoId et label depuis le nom du fichier
      const matches = s3Key.match(/\/([a-f0-9-]{36})-([a-zA-Z0-9_]+)-/);

      let photoId: string | null = null;
      let label: string | null = null;
      if (matches) {
        photoId = matches[1];
        label = matches[2];
      }

      if (!photoId || !label) {
        this.$bvToast.toast('Impossible d’identifier la photo à signaler.', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        });
        return;
      }

      // Appel API
      const apiResp = await axios.post('https://vamg432ym2.execute-api.eu-west-3.amazonaws.com/prod/delete-photo', {
        s3Key,
        photoId,
        label,
      });

      console.log(axiosResponse.data);
      this.$bvToast.toast('Fausse détection signalée avec succès.', {
        title: 'Succès',
        variant: 'success',
        solid: true,
      });
      // Optionnel : Supprimer l'image de la liste après signalement
      this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
    } catch (error) {
      // Vérifier si l'erreur contient "Network Error"
      const errorStr = error && error.toString ? error.toString() : '';
      if (errorStr.includes('Network Error')) {
        console.log("Network Error détecté, mais l'upload semble réussi d'après les logs réseau.");
        this.$bvToast.toast('Fausse détection signalée avec succès.', {
          title: 'Succès',
          variant: 'success',
          solid: true,
        });
        // Optionnel : Supprimer l'image de la liste après signalement
        this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
        try {
          await axios.post('https://ncv8s6bnc5.execute-api.eu-west-3.amazonaws.com/prod/send-email', {});
          console.log('Email de notification envoyé via Lambda.');
        } catch (emailError) {
          console.error("Erreur lors de l'envoi de l'email :", emailError);
        }
      } else {
        console.error('Erreur lors du signalement:', error);
        this.$bvToast.toast('Erreur lors du signalement.', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        });
      }
    }
  }

  private async reportFalseDetectionroboflowseg(index: number) {
    const falseDetection = this.boundingBoxImages[index];
    console.log('False detection', falseDetection);
    try {
      // Récupérer l’URL publique de l’image depuis S3
      const imageUrl = await Storage.get(falseDetection.key, { level: 'public' });
      // Télécharger l’image et la convertir en Blob
      const response = await fetch(imageUrl as string);
      const blob = await response.blob();

      // Créer un FormData pour l’envoi vers Roboflow
      const formData = new FormData();
      // On génère un nom de fichier basé sur l’heure et le label (à adapter selon vos besoins)
      const fileName = `reported-${Date.now()}-${falseDetection.label}.jpg`;
      formData.append('name', fileName);
      formData.append('file', blob, fileName);
      // On peut indiquer le split (par exemple "train")
      formData.append('split', 'train');

      // Configuration de Roboflow : remplacez par vos informations
      const ROBOFLOW_API_KEY = 'sMvFYAUEXICXjfJaPDAs';
      const ROBOFLOW_DATASET = 'excavation-2';

      // Envoyer l'image à Roboflow via axios
      const axiosResponse = await axios.post(`https://api.roboflow.com/dataset/${ROBOFLOW_DATASET}/upload`, formData, {
        params: {
          api_key: ROBOFLOW_API_KEY,
        },
      });

      // === SUPPRESSION S3 ===
      let s3Key = falseDetection.key;
      if (!s3Key.startsWith('public/')) {
        s3Key = 'public/' + s3Key;
      }
      const matches = s3Key.match(/Segmentation\/([a-z0-9-]{36})-([a-zA-Z0-9_]+)-/);

      let photoId: string | null = null;
      let label: string | null = null;
      if (matches) {
        photoId = matches[1];
        label = matches[2];
      }

      if (!photoId || !label) {
        this.$bvToast.toast('Impossible d’identifier la photo à signaler.', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        });
        return;
      }

      const apiResp = await axios.post('https://vamg432ym2.execute-api.eu-west-3.amazonaws.com/prod/delete-photo', {
        s3Key,
        photoId,
        label,
      });

      this.$bvToast.toast('Fausse détection signalée avec succès.', {
        title: 'Succès',
        variant: 'success',
        solid: true,
      });
      // Optionnel : Supprimer l'image de la liste après signalement
      this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
    } catch (error) {
      // Vérifier si l'erreur contient "Network Error"
      const errorStr = error && error.toString ? error.toString() : '';
      if (errorStr.includes('Network Error')) {
        console.log("Network Error détecté, mais l'upload semble réussi d'après les logs réseau.");
        this.$bvToast.toast('Fausse détection signalée avec succès.', {
          title: 'Succès',
          variant: 'success',
          solid: true,
        });
        // Optionnel : Supprimer l'image de la liste après signalement
        this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
        try {
          await axios.post('https://ncv8s6bnc5.execute-api.eu-west-3.amazonaws.com/prod/send-email', {});
          console.log('Email de notification envoyé via Lambda.');
        } catch (emailError) {
          console.error("Erreur lors de l'envoi de l'email :", emailError);
        }
      } else {
        console.error('Erreur lors du signalement:', error);
        this.$bvToast.toast('Erreur lors du signalement.', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        });
      }
    }
  }

  private async reportFalseDetection(index: number) {
    const falseDetection = this.boundingBoxImages[index];
    try {
      // Récupérer la clé S3 de l'image à signaler
      const imageKey = falseDetection.key;

      // Télécharger l'image en tant que Blob
      const imageUrl = (await Storage.get(imageKey, { download: true })) as string;
      // Utiliser fetch pour obtenir l'image en tant que Blob
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      // Créer un nom de fichier unique pour l'image signalée
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      const fileExtension = imageKey.split('.').pop()?.split('?')[0] || 'jpg'; // Extraire l'extension depuis la clé
      const fileName = `false-detections-bucket/${this.id}/${this.cameraSelected}/${timestamp}-${falseDetection.label}.${fileExtension}`;

      // Télécharger l'image vers le bucket S3 dédié
      await Storage.put(fileName, blob, {
        contentType: blob.type,
        level: 'public', // Utilisez 'private' si vous souhaitez restreindre l'accès
      });

      // Optionnel : Sauvegarder des métadonnées sur le signalement
      const reportData = {
        label: falseDetection.label,
        confidence: falseDetection.confidence,
        originalImageKey: imageKey,
        reportedAt: new Date().toISOString(),
        projectId: this.id,
        cameraId: this.cameraSelected,
        userId: this.$store.state.user?.id || 'unknown',
        userName: this.$store.state.user?.name || 'unknown',
      };

      // Créer un fichier JSON de métadonnées
      const metadataFileName = `false-detections/${this.id}/${this.cameraSelected}/${timestamp}-${falseDetection.label}.json`;
      const metadataBlob = new Blob([JSON.stringify(reportData, null, 2)], { type: 'application/json' });

      await Storage.put(metadataFileName, metadataBlob, {
        contentType: 'application/json',
        level: 'public', // Ou 'private'
      });

      await Storage.remove(imageKey, { level: 'public' });

      // Ajouter la détection signalée à la liste des fausses détections
      this.falseDetections.push(falseDetection);

      // Afficher un message de succès
      this.$bvToast.toast('Fausse détection signalée avec succès.', {
        title: 'Succès',
        variant: 'success',
        solid: true,
      });

      // Optionnel : Supprimer la détection de l'affichage
      // this.boundingBoxImages.splice(index, 1);
      // Si vous utilisez `filteredBoundingBoxImages`, mettez à jour `boundingBoxImages` en conséquence
      this.boundingBoxImages = this.boundingBoxImages.filter((_, i) => i !== index);
    } catch (error) {
      console.error('Erreur lors du signalement:', error);
      this.$bvToast.toast('Erreur lors du signalement.', {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
    }
  }

  private handleChartClick(eventData: any): void {
    if (eventData.points && eventData.points.length > 0) {
      const point = eventData.points[0];

      // Récupérer l'heure de l'objet `Date` de `point.x`
      const clickedDate = new Date(point.x);

      // Vérifier si l'heure est `00:00:00`
      // Vérifier si l'heure est exactement à minuit en comparant la différence de temps
      const isMidnight = clickedDate.getTime() % (24 * 60 * 60 * 1000) === 0;

      if (isMidnight) {
        // Si l'heure est `00:00:00`, la définir à `12:00:00`
        clickedDate.setHours(12, 0, 0, 0);
      }

      // Récupérer les `photoIds` depuis `customdata`
      const photoIds: string[] = Array.isArray(point.customdata) ? point.customdata : [point.customdata];

      // Trouver les photos correspondantes dans le store des photos
      const selectedPhotos = this.dataImagesKey
        .map((item) => item.data) // extraire les Photo
        .filter((photo) => photoIds.includes(photo.id));

      // Sélectionner la photo la plus proche en heure si plusieurs photos existent pour une même date
      if (selectedPhotos.length > 0) {
        const closestPhoto = selectedPhotos.reduce((closest, photo) => {
          const photoTime = new Date(photo.createdAt).getTime();
          const clickedTime = clickedDate.getTime();
          const closestTime = new Date(closest.createdAt).getTime();

          return Math.abs(photoTime - clickedTime) < Math.abs(closestTime - clickedTime) ? photo : closest;
        }, selectedPhotos[0]);

        // Mettre à jour la photo sélectionnée avec celle qui correspond le mieux
        this.selectedPhotos = [closestPhoto];
      } else {
        console.warn('Aucune photo correspondante trouvée.');
        this.selectedPhotos = [];
      }
    }
  }

  private async updateChartForActivityReport(data: any[]): Promise<void> {
    const preparedData = this.prepareData(data);

    // Seules les courbes de densité et d'activité
    const traces: Partial<Plotly.PlotData>[] = this.createTraces(preparedData, false) as Partial<Plotly.PlotData>[]; // false désactive l'affichage des barres

    // Explicitly set the trace type as "scatter" if not already defined within `createTraces`
    traces.forEach((trace) => {
      if (!trace.type) {
        trace.type = 'scatter';
      }
    });

    const layout = this.createLayout();
    const config = this.createConfig();

    const plotDiv: any = document.getElementById('chart');
    await Plotly.react(plotDiv, traces as Plotly.Data[], layout, config);
  }

  private createLayout() {
    return {
      barmode: 'stack',
      bargap: 0.05,
      modebar: {
        orientation: 'v',
        bgcolor: '#001a35',
        color: '#6c757d',
        activecolor: '#5fc9e4',
      },
      xaxis: {
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        type: 'date',
        tickformat: '%d/%m/%Y',
        autorange: true,
      },
      yaxis: {
        autorange: true,
        color: '#5fc9e4',
        gridcolor: '#314a644a',
        title: {
          text: 'Nombre total',
          standoff: 100, // Ajoute de l'espace entre l'axe et la légende
        },
        anchor: 'x',
      },
      yaxis2: {
        title: {
          text: 'Port EPI (%) & Mouvement (%)',
          standoff: 10, // Ajoute de l'espace entre l'axe et la légende
        },
        overlaying: 'y',
        side: 'right',
        tickformat: '.2f',
        showgrid: false,
        color: 'cyan',
        anchor: 'x',
        autorange: true,
      },
      margin: {
        l: 50,
        r: 100,
        b: 31,
        t: 10,
        pad: 0,
      },
      paper_bgcolor: 'transparent',
      plot_bgcolor: 'transparent',
      legend: {
        x: 0,
        xanchor: 'left' as const,
        y: 1.04,
        yanchor: 'middle' as const,
        orientation: 'h' as const,
        font: {
          color: '#5fc9e4',
        },
      },
    } as Partial<Plotly.Layout>;
  }

  private createConfig() {
    return {
      responsive: true,
      scrollZoom: true,
      displaylogo: false,
      doubleClick: 'reset',
      displayModeBar: true,
      modeBarButtonsToRemove: ['lasso2d', 'select2d'] as Plotly.ModeBarDefaultButtons[],
    } as Partial<Plotly.Config>;
  }

  private triggerLogoUpload() {
    (this.$refs.logoInput as HTMLInputElement).click();
  }

  private async handleLogoUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      console.error('❌ Aucun fichier sélectionné.');
      return;
    }

    try {
      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project?.owner?.id;
      const projectID = this.project?.id;
      if (!ownerID || !projectID) {
        console.error("❌ Impossible de récupérer l'ID du projet ou du propriétaire.");
        return;
      }

      const fileName = `logo-${Date.now()}.${file.name.split('.').pop()}`;
      const key = `public/${ownerID}/${projectID}/Logo/${fileName}`;

      const fileBuffer = await file.arrayBuffer();

      await s3
        .putObject({
          Bucket: 'erige-main-store-prod',
          Key: key,
          Body: Buffer.from(fileBuffer),
          ContentType: file.type,
          ACL: 'public-read',
        })
        .promise();

      console.log('✅ Logo uploadé avec succès:', key);
      this.fetchLogoUrl(); // Met à jour l'affichage après upload
    } catch (error) {
      console.error("❌ Erreur lors de l'upload du logo:", error);
    }
  }

  public async fetchLogoUrl() {
    try {
      if (!this.project || !this.project.owner) {
        console.warn('❌ `project` ou `project.owner` est indéfini. Attente...');
        return;
      }

      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;

      console.log('🔹 Récupération du logo pour ownerID:', ownerID, 'projectID:', projectID);

      const prefix = `public/${ownerID}/${projectID}/Logo/`;

      const response = await s3
        .listObjectsV2({
          Bucket: 'erige-main-store-prod',
          Prefix: prefix,
        })
        .promise();

      if (response.Contents && response.Contents.length > 0) {
        const lastFile = response.Contents.sort(
          (a, b) => (b.LastModified?.getTime() || 0) - (a.LastModified?.getTime() || 0)
        )[0];

        if (lastFile && lastFile.Key) {
          this.logoUrl = s3.getSignedUrl('getObject', {
            Bucket: 'erige-main-store-prod',
            Key: lastFile.Key,
            Expires: 3600,
          });

          console.log('✅ URL du logo récupérée :', this.logoUrl);
        }
      } else {
        console.warn('❌ Aucun logo trouvé dans le bucket.');
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du logo :', error);
    }
  }

  private async deleteAllLogos() {
    try {
      if (!this.project || !this.project.owner) return;

      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;
      const prefix = `public/${ownerID}/${projectID}/Logo/`;

      // Liste des fichiers à supprimer
      const response = await s3.listObjectsV2({ Bucket: 'erige-main-store-prod', Prefix: prefix }).promise();
      if (!response.Contents || response.Contents.length === 0) {
        console.warn('❌ Aucun logo à supprimer.');
        return;
      }

      const deleteParams = {
        Bucket: 'erige-main-store-prod',
        Delete: { Objects: response.Contents.map((item) => ({ Key: item.Key! })) },
      };

      await s3.deleteObjects(deleteParams).promise();
      this.logoUrl = null; // Supprime l'affichage du logo après suppression
      console.log('✅ Tous les logos ont été supprimés.');
    } catch (error) {
      console.error('❌ Erreur lors de la suppression des logos:', error);
    }
  }

  @Watch('projects')
  public onProjectsLoaded(val: Project[], oldVal: Project[]): void {
    logger.info('onProjectsLoaded', { val, oldVal });
    this.project = this.projectWithId(this.id);
    this.setProject(this.project);
    this.isProjectLoading = false; // Le chargement est terminé
  }
  @Watch('project')
  public async onProjectLoaded(val: Project | null, oldVal: Project | null): Promise<void> {
    logger.info('onProjectLoaded', { val, oldVal });
    if (val !== null) {
      this.onCameraSelectedChange();
    }
    await this.fetchLogoUrl();
  }

  @Watch('camera')
  @Watch('project')
  private async onDependenciesReady() {
    if (this.camera && this.project && this.dataImagesKey.length > 0) {
      await this.$nextTick();
      if (this.modeSelected === 'Sécurité') {
        this.createSecurityChart();
      } else {
        this.createChart();
      }
    }
  }

  @Watch('socketMessage.message')
  public onSocketMessageChange(val: NotificationMessage): void {
    if (val.timelapse !== undefined && val.projectId === this.id && val.cameraId === this.cameraSelected) {
      switch (val.timelapse) {
        case 'ready':
          logger.info('ready');
          this.timelapseRending = false;
          this.loadTimelapse().then(() => {
            this.disconnectSocket();
          });
          break;
      }
    }
  }

  @Watch('cameraSelected')
  public async onCameraSelectedChange(): Promise<void> {
    if (this.cameraSelected && !this.loadingTimelapse) {
      await this.loadCameraPhotos();
      this.$nextTick(() => {
        if (this.dataImagesKey.length > 0) {
          if (this.modeSelected === 'Sécurité') {
            this.createSecurityChart();
          } else {
            this.createChart();
          }
        }
      });
    }
    await this.loadPolygonPoints();
    await this.preloadBackgroundImage();
  }

  private async preloadBackgroundImage(): Promise<void> {
    let photo: Photo | null = null;
    if (this.selectedPhotos && this.selectedPhotos.length > 0) {
      photo = this.selectedPhotos[this.selectedPhotos.length - 1];
    } else if (this.dataImagesKey && this.dataImagesKey.length > 0) {
      photo = this.dataImagesKey[this.dataImagesKey.length - 1].data;
    }
    if (!photo) return;

    try {
      const key = photo.key || photo.smallKey;
      const photoUrl = await Storage.get(key);
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        this.preloadedImage = img;
      };
      img.src = photoUrl as string;
    } catch (error) {
      console.error("Erreur lors du préchargement de l'image:", error);
    }
  }

  @Watch('startDate')
  private onStartDateChange(): void {
    if (this.updatingFromChart) return;
    if (!this.updatingFromDateRange) this.resetButtonSelection();
    if (this.modeSelected === 'Sécurité') {
      this.createSecurityChart();
    } else {
      this.createChart();
    }
  }

  @Watch('endDate')
  private onEndDateChange(): void {
    if (this.updatingFromChart) return;
    if (!this.updatingFromDateRange) this.resetButtonSelection();
    if (this.modeSelected === 'Sécurité') {
      this.createSecurityChart();
    } else {
      this.createChart();
    }
  }

  @Watch('modeSelected')
  private async onModeChanged(newMode: string) {
    this.isChartInitialized = false;
    if (newMode === 'Sécurité') {
      this.activateSecurityMode();
    } else {
      this.activateDetectionMode();
    }
  }

  private activateDetectionMode() {
    this.createChart();
    this.showBoundingBoxes = true;
  }

  private activateSecurityMode() {
    this.createSecurityChart();
    this.showBoundingBoxes = false;
  }

  // drapeau pour le template
  private showBoundingBoxes = true;
}
